"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9725],{

/***/ 2850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92591);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  [data-autobot-element-id^='DATEPICKER_DAY']:focus {\n    outline: 5px auto -webkit-focus-ring-color;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CalendarWrapperBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-4316cfa7-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (CalendarWrapperBox);


/***/ }),

/***/ 20812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function useOutsideWrapper(ref, setIsPanelOpen) {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleClickOutside = /**
     * Closes panel if clicked on outside
     */ function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsPanelOpen(false);
            }
        };
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref,
        setIsPanelOpen
    ]);
}
function OutsideWrapper(param) {
    var children = param.children, setIsPanelOpen = param.setIsPanelOpen;
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    useOutsideWrapper(wrapperRef, setIsPanelOpen);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: wrapperRef,
        children: children
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (OutsideWrapper);


/***/ }),

/***/ 43484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92591);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23341);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98028);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84498);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86741);
/* harmony import */ var pcln_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32667);
/* harmony import */ var pcln_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53666);







var DateField = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(function(_param, ref) {
    var name = _param.name, _label = _param.label, label = _label === void 0 ? "" : _label, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, value = _param.value, _error = _param.error, error = _error === void 0 ? "" : _error, _errorZIndex = _param.errorZIndex, errorZIndex = _errorZIndex === void 0 ? 1 : _errorZIndex, _hideTooltip = _param.hideTooltip, hideTooltip = _hideTooltip === void 0 ? false : _hideTooltip, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "name",
        "label",
        "placeholder",
        "value",
        "error",
        "errorZIndex",
        "hideTooltip"
    ]);
    var dateFieldLargerStyle = value ? {
        height: "56px",
        paddingTop: "18px",
        paddingBottom: "10px"
    } : {
        height: "56px"
    };
    var showError = !hideTooltip && error !== "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        autoHide: true,
                        htmlFor: name,
                        width: "auto",
                        children: label
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        color: "primary"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        "data-datepicker": true
                    }, props), {
                        color: error ? "error" : "",
                        id: name,
                        name: name,
                        borderRadius: "lg",
                        placeholder: placeholder || label,
                        value: value,
                        autoComplete: "off",
                        readOnly: true,
                        style: dateFieldLargerStyle,
                        ref: ref
                    })),
                    showError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_icons__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        color: "error",
                        size: 20
                    })
                ]
            }),
            showError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                bottom: true,
                right: true,
                color: "error",
                zIndex: errorZIndex,
                children: error
            })
        ]
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (DateField);


/***/ }),

/***/ 51217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$l": function() { return /* binding */ hasHotel; },
/* harmony export */   "Hl": function() { return /* binding */ STAY_DRIVE; },
/* harmony export */   "IN": function() { return /* binding */ HOTEL; },
/* harmony export */   "Ow": function() { return /* binding */ CAR; },
/* harmony export */   "SL": function() { return /* binding */ hasFlight; },
/* harmony export */   "Ss": function() { return /* binding */ STAY_FLY_DRIVE; },
/* harmony export */   "Up": function() { return /* binding */ isHotelPlusCar; },
/* harmony export */   "b": function() { return /* binding */ STAY_FLY; },
/* harmony export */   "jb": function() { return /* binding */ TripTypeInfos; },
/* harmony export */   "qQ": function() { return /* binding */ FLIGHT; },
/* harmony export */   "sc": function() { return /* binding */ TripTypeLabel; },
/* harmony export */   "yv": function() { return /* binding */ FLY_DRIVE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98028);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  text-size-adjust: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * TripType Constants
 */ var STAY_FLY = "STAY:FLY";
var STAY_FLY_DRIVE = "STAY:FLY:DRIVE";
var FLY_DRIVE = "FLY:DRIVE";
var STAY_DRIVE = "STAY:DRIVE";
var HOTEL = "STAY";
var FLIGHT = "FLY";
var CAR = "DRIVE";
var _obj;
/**
 * TripType Info
 */ var TripTypeInfos = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, STAY_FLY, {
    id: "tripTypeAH",
    tripType: "STAY:FLY",
    typeLabel: "Hotel + Flight"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, STAY_FLY_DRIVE, {
    id: "tripTypeAHC",
    tripType: "STAY:FLY:DRIVE",
    typeLabel: "Hotel + Flight + Car"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, FLY_DRIVE, {
    id: "tripTypeAC",
    tripType: "FLY:DRIVE",
    typeLabel: "Flight + Car"
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, STAY_DRIVE, {
    id: "tripTypeHC",
    tripType: "STAY:DRIVE",
    typeLabel: "Hotel + Car"
}), _obj);
/**
 * TripType common UI
 */ var TripTypeLabel = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c2ae57a9-0"
})(_templateObject());
/**
 * TripType predicates
 */ var isHotelPlusCar = function(tripType) {
    return tripType === STAY_DRIVE;
};
var hasHotel = function(tripType) {
    return tripType.includes(HOTEL);
};
var hasFlight = function(tripType) {
    return tripType.includes(FLIGHT);
};


/***/ }),

/***/ 57812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J2": function() { return /* binding */ Popover; },
  "OI": function() { return /* binding */ PopoverContainer; }
});

// UNUSED EXPORTS: PopoverRootContainer

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js
var index_esm = __webpack_require__(99278);
// EXTERNAL MODULE: ./node_modules/@styled-system/theme-get/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(37138);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils = __webpack_require__(67113);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Hide/Hide.js
var Hide = __webpack_require__(87709);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowLeft.js
var ArrowLeft = __webpack_require__(88410);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
;// CONCATENATED MODULE: ./src/utils/scroll-animate.ts

function easeInOutQuad(t, b, c, d) {
    // eslint-disable-next-line no-param-reassign
    t /= d / 2;
    if (t < 1) {
        return c / 2 * t * t + b;
    }
    // eslint-disable-next-line no-plusplus, no-param-reassign
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
}
var ScrollAnimate = /*#__PURE__*/ function() {
    "use strict";
    function ScrollAnimate() {
        (0,_class_call_check/* default */.Z)(this, ScrollAnimate);
    }
    var _proto = ScrollAnimate.prototype;
    // eslint-disable-next-line class-methods-use-this
    _proto.scrollTo = function scrollTo(to) {
        var callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
            return undefined;
        }, duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 500;
        var move = function move(amount) {
            document.documentElement.scrollTop = amount;
            document.body.scrollTop = amount;
        };
        var getPosition = function() {
            return document.documentElement.scrollTop || document.body.scrollTop;
        };
        var start = getPosition();
        var change = to - start;
        var increment = 20;
        var currentTime = 0;
        var animateScroll = function() {
            var requestAnimFrame = function() {
                return window.requestAnimationFrame || function(cb) {
                    window.setTimeout(cb, 1000 / 60);
                };
            }();
            currentTime += increment;
            var val = easeInOutQuad(currentTime, start, change, duration);
            move(val);
            if (currentTime < duration) {
                requestAnimFrame(animateScroll);
            } else if (callback) {
                callback();
            }
        };
        animateScroll();
    };
    return ScrollAnimate;
}();
// eslint-disable-next-line import/prefer-default-export
var scrollAnimate = new ScrollAnimate();

;// CONCATENATED MODULE: ./src/utils/popover-scroll-helper.ts

var isDeviceOrientationPortrait = function() {
    if (window.orientation === 0 || window.orientation === 180) {
        return true;
    }
    return false;
};
var isWebKitBrowser = function() {
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    return iOS && webkit;
};
function scrollToTop() {
    if (isWebKitBrowser() && isDeviceOrientationPortrait()) {
        scrollAnimate.scrollTo(0);
    }
}
function restoreScrollPosition(scrollToYCoordinates) {
    if (isWebKitBrowser() && isDeviceOrientationPortrait() && scrollToYCoordinates) {
        scrollAnimate.scrollTo(scrollToYCoordinates);
    }
}

;// CONCATENATED MODULE: ./src/components/Popover.tsx






function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  right: 0;\n  bottom: 0;\n  left: 0;\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform-origin: top center;\n  &.fade-enter {\n    opacity: 0;\n    transform: rotateX(-45deg);\n    transition: all 200ms linear;\n  }\n  &.fade-enter-active {\n    opacity: 1;\n    transform: rotateX(0);\n  }\n  &.fade-exit {\n    opacity: 1;\n    transform: rotateX(0);\n  }\n  &.fade-exit-active {\n    opacity: 0;\n    transform: rotateX(-45deg);\n    transition: all 200ms linear;\n  }\n\n  flex: 1 1 auto;\n  height: ",
        ";\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  ",
        " ",
        " ",
        " {\n    position: absolute;\n    overflow: visible;\n    height: auto;\n  }\n\n  /* hack for calendar scroll issue */\n  & > div {\n    ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var Root = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-f699bec9-0"
})(_templateObject(), function(props) {
    return props.open ? (0,_define_property/* default */.Z)({
        position: "fixed",
        perspective: "600px",
        zIndex: props.zIndex || 0,
        top: props.top || 0,
        display: "flex",
        flexDirection: "column",
        backgroundColor: (0,utils/* getPaletteColor */.ow)("".concat(props.color), "background.lightest")
    }, (0,dist_index_esm/* themeGet */.R)("mediaQueries.1")(props), {
        position: "relative",
        top: "auto",
        display: "block"
    }) : null;
});
function Popover(_param) {
    var _open = _param.open, open = _open === void 0 ? false : _open, onDismiss = _param.onDismiss, _domSelectorForVisuallyContainedElement = _param.domSelectorForVisuallyContainedElement, domSelectorForVisuallyContainedElement = _domSelectorForVisuallyContainedElement === void 0 ? "" : _domSelectorForVisuallyContainedElement, props = (0,_object_without_properties/* default */.Z)(_param, [
        "open",
        "onDismiss",
        "domSelectorForVisuallyContainedElement"
    ]);
    var root = (0,react.useRef)({});
    var mounted = (0,react.useRef)({}) // Used to implement componentDidUpdate logic in hooks
    ;
    (0,react.useEffect)(function() {
        var handleDismiss = function(event) {
            if (!open || !root.current || root.current.contains(event.target)) return;
            if (domSelectorForVisuallyContainedElement && typeof event.target.closest === "function" && event.target.closest(domSelectorForVisuallyContainedElement)) {
                return;
            }
            if (onDismiss) {
                onDismiss(event);
            }
        };
        document.addEventListener("click", handleDismiss);
        return function() {
            document.removeEventListener("click", handleDismiss);
        };
    }, [
        open,
        domSelectorForVisuallyContainedElement,
        onDismiss
    ]);
    (0,react.useEffect)(function() {
        if (!mounted.current) {
            mounted.current = true;
        }
    }, []);
    (0,react.useEffect)(function() {
        // The useEffect hook here mimics the componentDidUpdate life-cycle hook
        // The scrollY position stored can be used in the return function and passed to restoreScrollPosition
        // In this way we can avoid storing the scrollY in any state in the Popover
        var scrollYPosition = window.scrollY;
        if (mounted.current && open === true) {
            scrollToTop();
        }
        return function() {
            if (!mounted.current) return;
            if (open === true) {
                restoreScrollPosition(scrollYPosition);
            }
        };
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Root, (0,_object_spread/* default */.Z)({
        ref: function(ref) {
            root.current = ref;
        },
        open: open
    }, props));
}
var left = (0,index_esm/* style */.oB)({
    prop: "left",
    cssProperty: "left"
});
var right = (0,index_esm/* style */.oB)({
    prop: "right",
    cssProperty: "right"
});
/*
On mounting, the calendar needs to scroll to the selected dates
This will be addressed in v2 date picker (desktop), but mobile (unconfirmed)
*/ var calendarHeight = function(props) {
    return props.isCalendar ? {
        height: "100%"
    } : null;
};
Popover.Body = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-f699bec9-1"
})(_templateObject1(), function(props) {
    return props.openState ? "calc(96vh - 64px)" : 0;
}, left, right, (0,dist_index_esm/* themeGet */.R)("mediaQueries.1"), calendarHeight);
// Simpler API
function PopoverRootContainer(_param) {
    var _open = _param.open, open = _open === void 0 ? false : _open, tmp = _param["data-calendar"], isCalendar = tmp === void 0 ? false : tmp, onDismiss = _param.onDismiss, children = _param.children, _position = _param.position, position = _position === void 0 ? "left" : _position, _leftPos = _param.leftPos, leftPos = _leftPos === void 0 ? 0 : _leftPos, _rightPos = _param.rightPos, rightPos = _rightPos === void 0 ? 0 : _rightPos, _popoverButtonProps = _param.popoverButtonProps, popoverButtonProps = _popoverButtonProps === void 0 ? {} : _popoverButtonProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "open",
        "data-calendar",
        "onDismiss",
        "children",
        "position",
        "leftPos",
        "rightPos",
        "popoverButtonProps"
    ]);
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.Children.toArray(children), 2), top = ref1[0], body = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        open: open,
        onDismiss: onDismiss,
        width: 1
    }), open ? {
        zIndex: 2
    } : {}), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            p: open ? [
                3,
                null,
                0
            ] : 0,
            mt: open && isMobile ? 2 : 0,
            pb: open ? [
                2,
                null,
                0
            ] : 0,
            color: "background.lightest",
            borderRadius: [
                "2xl",
                null,
                "lg"
            ],
            rounded: isMobile ? "top" : undefined,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    alignItems: "center",
                    children: [
                        open && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            md: true,
                            lg: true,
                            xl: true,
                            xxl: true,
                            pr: 2,
                            pb: [
                                3,
                                null,
                                0
                            ],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                size: "large",
                                "data-testid": "popover-back-button",
                                onClick: function(event) {
                                    event.preventDefault();
                                    if (onDismiss) {
                                        onDismiss(event);
                                    }
                                }
                            }, popoverButtonProps), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeft/* default */.Z, {})
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: 1,
                            pb: [
                                3,
                                null,
                                0
                            ],
                            children: top
                        })
                    ]
                }),
                open && /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover.Body, {
                    color: isCalendar ? undefined : "background.lightest",
                    openState: open,
                    isCalendar: isCalendar,
                    right: position === "right" ? "".concat(rightPos, "px") : null,
                    left: position === "left" ? "".concat(leftPos, "px") : null,
                    mt: [
                        0,
                        null,
                        isCalendar ? 2 : 0
                    ],
                    mr: [
                        0,
                        0,
                        -3,
                        0
                    ],
                    width: [
                        null,
                        null,
                        isCalendar ? null : 1
                    ],
                    children: body
                })
            ]
        })
    }));
}
var PopoverContainer = (0,styled_components_browser_esm/* withTheme */.Zz)(PopoverRootContainer);


/***/ }),

/***/ 17975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SearchFormButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8316);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15072);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 56px;\n  &:hover {\n    transform: scale(",
        ");\n    box-shadow: ",
        ";\n    transition: 0.2s ease-in-out;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP).withConfig({
    componentId: "sc-266892e-0"
})(_templateObject(), function(props) {
    return props.scale;
}, function(props) {
    return props.animatedBoxShadow;
});
function SearchFormButton(_param) {
    var buttonText = _param.buttonText, _handleClick = _param.handleClick, handleClick = _handleClick === void 0 ? function() {
    // empty default function
    } : _handleClick, buttonProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "buttonText",
        "handleClick"
    ]);
    var buttonMicroAnimationProps = {
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        scale: pcln_design_system__WEBPACK_IMPORTED_MODULE_6__/* .theme.scale["scale-100"] */ .rS.scale["scale-100"] + pcln_design_system__WEBPACK_IMPORTED_MODULE_6__/* .theme.scale["scale-2"] */ .rS.scale["scale-2"],
        animatedBoxShadow: pcln_design_system__WEBPACK_IMPORTED_MODULE_6__/* .theme.shadows.xl */ .rS.shadows.xl
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        width: 1,
        px: 1,
        py: 0,
        size: "large",
        onClick: handleClick,
        type: "submit",
        borderRadius: "lg"
    }, buttonProps, buttonMicroAnimationProps), {
        children: buttonText
    }));
}


/***/ }),

/***/ 10843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ ShadowEffect; }
/* harmony export */ });
/* unused harmony exports NoShadowEffect, createShadowEffectWhen */
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92591);
/* eslint-disable react/destructuring-assignment */ 







function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: 10;\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 24, 51, 0.5);\n  pointer-events: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function() {};
// Element that creates the shadow effect style if enabled, or render an empty div if not
var ShadowEffectElement = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-23a58c7-0"
})(_templateObject());
var ShadowEffect = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ShadowEffect, _PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ShadowEffect);
    function ShadowEffect(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, ShadowEffect);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            isEnabled: false
        };
        _this.disableShadowState = function() {
            return _this.setState(function() {
                return {
                    isEnabled: false
                };
            });
        };
        _this.enableShadowState = function() {
            return _this.setState(function() {
                return {
                    isEnabled: true
                };
            });
        };
        _this.handleFocus = _this.enableShadowState;
        _this.handleBlur = _this.props.alternativeBlurHandling ? _this.handleAlternativeBlur.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this)) : _this.disableShadowState;
        return _this;
    }
    var _proto = ShadowEffect.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.alternativeBlurHandling) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            document.addEventListener("focusin", this.handleDocumentClick, true);
            // eslint-disable-next-line @typescript-eslint/unbound-method
            document.addEventListener("click", this.handleDocumentClick, true);
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.alternativeBlurHandling) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            document.removeEventListener("focusin", this.handleAlternativeBlur);
            // eslint-disable-next-line @typescript-eslint/unbound-method
            document.removeEventListener("click", this.handleAlternativeBlur);
        }
    };
    _proto.handleDocumentClick = function handleDocumentClick(e) {
        if (e.target && this.node && !this.node.contains(e.target)) {
            this.disableShadowState();
        }
    };
    _proto.handleAlternativeBlur = function handleAlternativeBlur(e) {
        var ref;
        var target = e.nativeEvent.relatedTarget;
        if (!target || !((ref = this.node) === null || ref === void 0 ? void 0 : ref.contains(target))) {
            this.setState(function() {
                return {
                    isEnabled: false
                };
            });
        }
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, children = _props.children, remainingProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_props, [
            "children"
        ]);
        var isEnabled = this.state.isEnabled;
        var ref = this, handleBlur = ref.handleBlur, handleFocus = ref.handleFocus, enableShadowState = ref.enableShadowState, disableShadowState = ref.disableShadowState;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
            width: 1,
            onBlur: handleBlur,
            onFocus: handleFocus
        }, remainingProps), {
            children: [
                isEnabled && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ShadowEffectElement, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    ref: function(node) {
                        _this.node = node;
                    },
                    style: {
                        width: "100%",
                        position: "relative",
                        zIndex: isEnabled ? 20 : "auto"
                    },
                    children: typeof children === "function" ? children({
                        isEnabled: isEnabled,
                        enableShadowState: enableShadowState,
                        disableShadowState: disableShadowState
                    }) : children
                })
            ]
        }));
    };
    return ShadowEffect;
}(react__WEBPACK_IMPORTED_MODULE_2__.PureComponent);

function NoShadowEffect(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: typeof children === "function" ? children({
            isEnabled: false,
            enableShadowState: noop,
            disableShadowState: noop
        }) : children
    });
}
var createShadowEffectWhen = function(condition) {
    return condition ? function(props) {
        return /*#__PURE__*/ _jsx(ShadowEffect, _object_spread({}, props));
    } : function(props) {
        return /*#__PURE__*/ _jsx(NoShadowEffect, _object_spread({}, props));
    };
};



/***/ }),

/***/ 47941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TravelerSelection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(86741);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./src/components/Popover.tsx + 2 modules
var Popover = __webpack_require__(57812);
// EXTERNAL MODULE: ./src/components/ClickOutsideWrapper.tsx
var ClickOutsideWrapper = __webpack_require__(20812);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Input/Input.js
var Input = __webpack_require__(84498);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/User.js
var User = __webpack_require__(16966);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils = __webpack_require__(67113);
;// CONCATENATED MODULE: ./src/components/TravelerSelection/StyledMenuButton.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  align-items: center;\n  height: 56px;\n  &:focus-visible {\n    outline: solid 3px ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &&& {\n    display: flex;\n    padding: 0px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledMenuButtonRemaining = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.ZP).withConfig({
    componentId: "sc-9dbc8c1-0"
})(_templateObject(), (0,utils/* getPaletteColor */.ow)("primary.base"));
// split the styles and added &&& to increase css rule specificity because of a bug in DS 4.16.2
// scrolling scroll down then up on hotels page breaks traveller selection
var StyledMenuButton = (0,styled_components_browser_esm/* default */.ZP)(StyledMenuButtonRemaining).withConfig({
    componentId: "sc-9dbc8c1-1"
})(_templateObject1());
/* harmony default export */ var TravelerSelection_StyledMenuButton = (StyledMenuButton);

;// CONCATENATED MODULE: ./src/components/TravelerSelection/Menu.tsx

function Menu_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  height: 56px;\n"
    ]);
    Menu_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Menu_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  width: calc(100% - ",
        "px);\n"
    ]);
    Menu_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var TEXT_MARGIN_LEFT = 36;
var StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-aa60851f-0"
})(Menu_templateObject());
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.ZP).withConfig({
    componentId: "sc-aa60851f-1"
})(Menu_templateObject1(), TEXT_MARGIN_LEFT);
function Menu(param) {
    var _isPanelOpen = param.isPanelOpen, isPanelOpen = _isPanelOpen === void 0 ? false : _isPanelOpen, _hasError = param.hasError, hasError = _hasError === void 0 ? false : _hasError, _label = param.label, label = _label === void 0 ? "" : _label, toggleMenu = param.toggleMenu, disabled = param.disabled, isMobile = param.isMobile;
    var borderColorValue = !isPanelOpen && hasError ? "error" : "borderGray";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TravelerSelection_StyledMenuButton, {
        disabled: disabled,
        type: "button",
        color: "text.lightest",
        width: 1,
        isMobile: isMobile,
        onClick: toggleMenu(isPanelOpen),
        borderColor: borderColorValue,
        "aria-label": "traveler-selection-control-panel",
        "aria-expanded": isPanelOpen,
        "aria-controls": "traveler-selection-control-panel",
        borderRadius: "lg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(User/* default */.Z, {
                color: "primary",
                size: 24,
                ml: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                fontSize: 1,
                fontWeight: 500,
                fontFamily: "inherit",
                ml: TEXT_MARGIN_LEFT,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                readOnly: true,
                type: "text",
                tabIndex: -1,
                "aria-live": "polite",
                borderRadius: "lg",
                "aria-atomic": "true",
                "aria-label": "traveler selection",
                id: "traveler-selection-readonly-input",
                "data-testid": "traveler-selection-readonly-input"
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Divider/Divider.js
var Divider = __webpack_require__(11477);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowRight.js
var ArrowRight = __webpack_require__(91209);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/IconButton/IconButton.js
var IconButton = __webpack_require__(14649);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/RadioMinus.js
var RadioMinus = __webpack_require__(71078);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/RadioPlus.js
var RadioPlus = __webpack_require__(55557);
;// CONCATENATED MODULE: ./src/components/TravelerSelection/utils.tsx
var WHITE_SPACE_REGEX = /\s+/g;
function removeWhiteSpace(value) {
    return value.replace(WHITE_SPACE_REGEX, "");
}
function lowerCaseFirstCharacter(value) {
    return value.charAt(0).toLowerCase() + value.slice(1);
}

;// CONCATENATED MODULE: ./src/components/TravelerSelection/OperationButton.tsx





function OperationButton(param) {
    var handleClick = param.handleClick, iconName = param.iconName, isDisabled = param.isDisabled, label = param.label;
    var modifiedLabel = lowerCaseFirstCharacter(removeWhiteSpace(label));
    var iconButtonId = "traveler-selection-".concat(modifiedLabel, "-").concat(iconName, "-button");
    var disabled = isDisabled ? " - disabled" : "";
    var ariaLabel = iconName === "radioMinus" ? "Decrease ".concat(label).concat(disabled) : "Increase ".concat(label).concat(disabled);
    var RadioIcon = iconName === "radioMinus" ? RadioMinus/* default */.Z : RadioPlus/* default */.Z;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
        "aria-label": ariaLabel,
        "aria-controls": "".concat(modifiedLabel, "-number"),
        id: iconButtonId,
        "data-testid": iconButtonId,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioIcon, {
            size: 24,
            color: isDisabled ? "border" : "primary"
        }),
        onClick: function(e) {
            e.preventDefault();
            if (!isDisabled) {
                handleClick();
            }
        },
        name: iconName,
        size: 24,
        style: {
            cursor: "pointer"
        }
    });
}

;// CONCATENATED MODULE: ./src/components/TravelerSelection/MenuItem.tsx





function MenuItem(param) {
    var isMinusIconButtonDisabled = param.isMinusIconButtonDisabled, isPlusIconButtonDisabled = param.isPlusIconButtonDisabled, label = param.label, setTravelers = param.setTravelers, subLabel = param.subLabel, _showSubLabel = param.showSubLabel, showSubLabel = _showSubLabel === void 0 ? false : _showSubLabel, _travelerCount = param.travelerCount, travelerCount = _travelerCount === void 0 ? 0 : _travelerCount, travelerKey = param.travelerKey;
    var TextSpan = Text/* default.span */.ZP.span;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        alignItems: "center",
        justifyContent: "space-between",
        px: 3,
        style: {
            height: 52
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextSpan, {
                fontSize: 2,
                children: [
                    label,
                    showSubLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSpan, {
                        color: "gray",
                        fontSize: 1,
                        ml: 1,
                        children: subLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OperationButton, {
                        handleClick: function() {
                            return setTravelers({
                                type: "REMOVE_TRAVELER",
                                travelerKey: travelerKey
                            });
                        },
                        iconName: "radioMinus",
                        isDisabled: isMinusIconButtonDisabled,
                        label: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        "aria-label": "".concat(label, " count"),
                        "aria-live": "polite",
                        "aria-atomic": "true",
                        fontSize: 2,
                        id: "".concat(lowerCaseFirstCharacter(removeWhiteSpace(label)), "-number"),
                        px: 2,
                        style: {
                            width: "1.6em"
                        },
                        textAlign: "center",
                        children: travelerCount
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OperationButton, {
                        handleClick: function() {
                            return setTravelers({
                                type: "ADD_TRAVELER",
                                travelerKey: travelerKey
                            });
                        },
                        iconName: "radioPlus",
                        label: label,
                        isDisabled: isPlusIconButtonDisabled
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/TravelerSelection/constants.ts
var constants = __webpack_require__(45588);
;// CONCATENATED MODULE: ./src/components/TravelerSelection/MenuItemsPanel.tsx



function MenuItemsPanel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n"
    ]);
    MenuItemsPanel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var LinkContainer = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-e2f9449-0"
})(MenuItemsPanel_templateObject());
function MenuItemsPanel(param) {
    var hotelPlannerLinkAttrs = param.hotelPlannerLinkAttrs, maxAdults = param.maxAdults, maxChildren = param.maxChildren, maxRooms = param.maxRooms, setTravelers = param.setTravelers, showInfantMenuItem = param.showInfantMenuItem, showRoomMenuItem = param.showRoomMenuItem, showSubLabel = param.showSubLabel, showYouthMenuItem = param.showYouthMenuItem, travelers = param.travelers;
    var adultCount = travelers.adultCount, childrenCount = travelers.childrenCount, infantCount = travelers.infantCount, roomCount = travelers.roomCount, youthCount = travelers.youthCount;
    var metas = [];
    var passengers = adultCount + youthCount + childrenCount + infantCount;
    var isMaxPassengers = passengers >= constants/* MAX_PASSENGERS */.mn;
    var isMaxAdults = maxAdults ? adultCount >= maxAdults : isMaxPassengers;
    var isMaxChildren = maxChildren ? childrenCount >= maxChildren : isMaxPassengers;
    var isMaxRoom = maxRooms || constants/* MAX_ROOMS */.yB;
    if (showRoomMenuItem) {
        metas.push({
            isMinusIconButtonDisabled: roomCount <= constants/* MIN_ROOMS */.nK,
            isPlusIconButtonDisabled: roomCount >= isMaxRoom,
            label: constants/* labels.ROOMS */.p8.ROOMS,
            subLabel: constants/* subLabels.ROOMS */.Qz.ROOMS,
            travelerCount: roomCount,
            travelerKey: "roomCount"
        });
    }
    metas.push({
        isMinusIconButtonDisabled: adultCount <= constants/* MIN_ADULTS */.cu,
        isPlusIconButtonDisabled: isMaxAdults,
        label: constants/* labels.ADULTS */.p8.ADULTS,
        subLabel: constants/* subLabels.ADULTS */.Qz.ADULTS,
        travelerCount: adultCount,
        travelerKey: "adultCount"
    });
    if (showYouthMenuItem) {
        metas.push({
            isMinusIconButtonDisabled: youthCount <= constants/* MIN_CHILDREN */._D,
            isPlusIconButtonDisabled: isMaxPassengers,
            label: constants/* labels.YOUTHS */.p8.YOUTHS,
            subLabel: constants/* subLabels.YOUTHS */.Qz.YOUTHS,
            travelerCount: youthCount,
            travelerKey: "youthCount"
        });
    }
    metas.push({
        isMinusIconButtonDisabled: childrenCount <= constants/* MIN_CHILDREN */._D,
        isPlusIconButtonDisabled: isMaxChildren || childrenCount >= 6,
        label: constants/* labels.CHILDREN */.p8.CHILDREN,
        subLabel: constants/* subLabels.CHILDREN */.Qz.CHILDREN,
        travelerCount: childrenCount,
        travelerKey: "childrenCount"
    });
    if (showInfantMenuItem) {
        metas.push({
            isMinusIconButtonDisabled: infantCount <= constants/* MIN_CHILDREN */._D,
            isPlusIconButtonDisabled: infantCount >= adultCount || isMaxPassengers,
            label: constants/* labels.INFANTS */.p8.INFANTS,
            subLabel: constants/* subLabels.INFANTS */.Qz.INFANTS,
            travelerCount: infantCount,
            travelerKey: "infantCount"
        });
    }
    var MenuItems = metas.map(function(param, index) {
        var label = param.label, subLabel = param.subLabel, travelerCount = param.travelerCount, isPlusIconButtonDisabled = param.isPlusIconButtonDisabled, isMinusIconButtonDisabled = param.isMinusIconButtonDisabled, travelerKey = param.travelerKey;
        var islastItem = index === metas.length - 1;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                    isMinusIconButtonDisabled: isMinusIconButtonDisabled,
                    isPlusIconButtonDisabled: isPlusIconButtonDisabled,
                    label: label,
                    setTravelers: setTravelers,
                    showSubLabel: showSubLabel,
                    subLabel: subLabel,
                    travelerCount: travelerCount,
                    travelerKey: travelerKey
                }),
                label === constants/* labels.ROOMS */.p8.ROOMS && travelerCount > constants/* MAX_PASSENGERS */.mn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    mb: 2,
                    px: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            color: "text.light",
                            fontSize: 0,
                            mb: 2,
                            children: "Need 10 or more rooms? Special group rates available with our hotel partner, hotelplanner.com"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, hotelPlannerLinkAttrs), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    fontSize: 0,
                                    children: "10 Rooms or More"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRight/* default */.Z, {
                                    ml: 1,
                                    size: 18
                                })
                            ]
                        }))
                    ]
                }) : null,
                !islastItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                    borderColor: "lightGray",
                    mx: 3,
                    my: 0
                })
            ]
        }, label);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: MenuItems
    });
}

// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Select/Select.js
var Select = __webpack_require__(16031);
;// CONCATENATED MODULE: ./src/components/TravelerSelection/ChildAgeSelect.tsx

function ChildAgeSelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    color: ",
        ";\n  }\n"
    ]);
    ChildAgeSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var AgeFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-438ad2f9-0"
})(ChildAgeSelect_templateObject(), (0,utils/* getPaletteColor */.ow)("primary.base"));
var selectStyle = {
    border: "none",
    cursor: "pointer",
    paddingLeft: 16,
    fontSize: 16,
    fontWeight: 700,
    width: 200
};
function ChildAgeSelect(param) {
    var childAge = param.childAge, childIndex = param.childIndex, updateAges = param.updateAges, childAgeSelectors = param.childAgeSelectors;
    var ageText = "yrs";
    var ageDefaultValue = childAge === undefined ? "Add Child ".concat(childIndex + 1) : childAge;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AgeFlex, {
        justifyContent: "center",
        my: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
            defaultValue: ageDefaultValue,
            onChange: function(e) {
                updateAges(Number(e.target.value), childIndex);
            },
            name: "childAgeSelect",
            style: selectStyle,
            title: "Select age for child ".concat(childIndex + 1),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    value: -1,
                    children: "Add Child ".concat(childIndex + 1)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    value: 0,
                    children: childAgeSelectors === null || childAgeSelectors === void 0 ? void 0 : childAgeSelectors.optionsText.infant
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    value: 1,
                    children: childAgeSelectors === null || childAgeSelectors === void 0 ? void 0 : childAgeSelectors.optionsText.oneYear
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 2,
                    children: [
                        "2 ",
                        ageText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 3,
                    children: [
                        "3 ",
                        ageText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 4,
                    children: [
                        "4 ",
                        ageText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 5,
                    children: [
                        "5 ",
                        ageText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 6,
                    children: [
                        "6 ",
                        ageText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 7,
                    children: [
                        "7 ",
                        ageText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 8,
                    children: [
                        "8 ",
                        ageText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 9,
                    children: [
                        "9 ",
                        ageText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 10,
                    children: [
                        "10 ",
                        ageText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 11,
                    children: [
                        "11 ",
                        ageText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 12,
                    children: [
                        "12 ",
                        ageText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 13,
                    children: [
                        "13 ",
                        ageText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 14,
                    children: [
                        "14 ",
                        ageText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 15,
                    children: [
                        "15 ",
                        ageText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 16,
                    children: [
                        "16 ",
                        ageText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                    value: 17,
                    children: [
                        "17 ",
                        ageText
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/TravelerSelection/ChildAgeSelectors.tsx



function ChildAgeSelectors(param) {
    var ages = param.ages, childrenCount = param.childrenCount, setTravelers = param.setTravelers, childAgeSelectors = param.childAgeSelectors;
    var updateAges = function(age, index) {
        var newAges = ages.slice();
        newAges[index] = age;
        setTravelers({
            type: "UPDATE_AGES",
            ages: newAges
        });
    };
    var childSelectRows = [];
    for(var i = 0; i < childrenCount; i++){
        childSelectRows.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(ChildAgeSelect, {
            childIndex: i,
            childAge: ages[i],
            updateAges: updateAges,
            childAgeSelectors: childAgeSelectors
        }, i));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: childSelectRows
    });
}

// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 238 modules
var es = __webpack_require__(67763);
;// CONCATENATED MODULE: ./src/components/TravelerSelection/renderMenuLabel.ts

var pluralizeWord = function(word) {
    var ending = word === "Child" ? "ren" : "s";
    return word + ending;
};
var formatLabel = function(count, traveler) {
    var travelerLabel = count > 1 ? pluralizeWord(traveler) : traveler;
    return "".concat(count, " ").concat(travelerLabel);
};
var renderMenuLabel = function(param) {
    var adultCount = param.adultCount, childrenCount = param.childrenCount, infantCount = param.infantCount, roomCount = param.roomCount, showInfantMenuItem = param.showInfantMenuItem, showRoomMenuItem = param.showRoomMenuItem, showYouthMenuItem = param.showYouthMenuItem, youthCount = param.youthCount;
    var adultLabel = adultCount > 0 ? formatLabel(adultCount, "Adult") : "";
    var childrenLabel = childrenCount > 0 ? formatLabel(childrenCount, "Child") : "";
    var infantLabel = showInfantMenuItem && infantCount > 0 ? formatLabel(infantCount, "Lap Infant") : "";
    var passengerCount = adultCount + childrenCount + youthCount + infantCount;
    var passengerLabel = passengerCount > 0 ? formatLabel(passengerCount, "Passenger") : "";
    var roomsLabel = showRoomMenuItem && roomCount > 0 ? formatLabel(roomCount, "Room") : "";
    var youthLabel = showYouthMenuItem && youthCount > 0 ? formatLabel(youthCount, "Youth") : "";
    var labels;
    if ((infantCount > 0 || youthCount > 0) && childrenCount > 0 || infantCount > 0 && youthCount > 0) {
        labels = [
            passengerLabel,
            roomsLabel
        ];
    } else {
        labels = [
            adultLabel,
            youthLabel,
            childrenLabel,
            infantLabel,
            roomsLabel
        ];
    }
    return (0,es/* join */.v_p)(", ", (0,es/* filter */.hXT)(function(label) {
        return label !== "";
    }, labels));
};
/* harmony default export */ var TravelerSelection_renderMenuLabel = (renderMenuLabel);

;// CONCATENATED MODULE: ./src/components/TravelerSelection/TravelerSelection.tsx




function TravelerSelection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  user-select: none;\n  z-index: 4;\n  border-color: transparent;\n"
    ]);
    TravelerSelection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TravelerSelection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  margin: 0 auto 16px auto;\n  width: 85%;\n"
    ]);
    TravelerSelection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  top: ",
        ";\n  pointer-events: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var errorTooltipBaseStyles = {
    bottom: true,
    color: "error",
    right: true,
    zIndex: 1
};
var MenuCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-f6358141-0"
})(TravelerSelection_templateObject());
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.ZP).withConfig({
    componentId: "sc-f6358141-1"
})(TravelerSelection_templateObject1());
var StyledPopover = (0,styled_components_browser_esm/* default */.ZP)(Popover/* Popover */.J2).withConfig({
    componentId: "sc-f6358141-2"
})(_templateObject2(), function(props) {
    return props.isMobile && props.open ? "16px" : 0;
}, function(props) {
    return props.isMobile && props.open ? "8px" : 0;
}, function(props) {
    return props.disabled ? "none" : undefined;
});
function travelerReducer(state, action) {
    var _ages = action.ages, ages = _ages === void 0 ? [] : _ages, travelerKey = action.travelerKey;
    switch(action.type){
        case "UPDATE_AGES":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    ages: ages
                });
            }
        case "ADD_TRAVELER":
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, travelerKey, state[travelerKey] + 1));
            }
        case "REMOVE_TRAVELER":
            {
                var newAges = travelerKey !== "adultCount" ? state.ages.slice(0, state.ages.length - 1) : state.ages;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({
                    ages: newAges
                }, travelerKey, state[travelerKey] - 1));
            }
        default:
            return state;
    }
}
function TravelerSelection(param) {
    var _adultCount = param.adultCount, adultCount = _adultCount === void 0 ? 0 : _adultCount, _childrenAges = param.childrenAges, childrenAges = _childrenAges === void 0 ? [] : _childrenAges, _childrenCount = param.childrenCount, childrenCount = _childrenCount === void 0 ? 0 : _childrenCount, disableShadowState = param.disableShadowState, disclaimer = param.disclaimer, error = param.error, hotelPlannerLinkAttrs = param.hotelPlannerLinkAttrs, _infantCount = param.infantCount, infantCount = _infantCount === void 0 ? 0 : _infantCount, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, maxAdults = param.maxAdults, maxChildren = param.maxChildren, maxRooms = param.maxRooms, onDoneButtonClick = param.onDoneButtonClick, _roomCount = param.roomCount, roomCount = _roomCount === void 0 ? 0 : _roomCount, setValue = param.setValue, _showChildAgeSelectors = param.showChildAgeSelectors, showChildAgeSelectors = _showChildAgeSelectors === void 0 ? false : _showChildAgeSelectors, _showInfantMenuItem = param.showInfantMenuItem, showInfantMenuItem = _showInfantMenuItem === void 0 ? false : _showInfantMenuItem, _showRoomMenuItem = param.showRoomMenuItem, showRoomMenuItem = _showRoomMenuItem === void 0 ? false : _showRoomMenuItem, _showSubLabel = param.showSubLabel, showSubLabel = _showSubLabel === void 0 ? false : _showSubLabel, _showYouthMenuItem = param.showYouthMenuItem, showYouthMenuItem = _showYouthMenuItem === void 0 ? false : _showYouthMenuItem, _youthCount = param.youthCount, youthCount = _youthCount === void 0 ? 0 : _youthCount, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, childAgeSelectors = param.childAgeSelectors;
    var ref = (0,react.useState)(false), isPanelOpen = ref[0], setIsPanelOpen = ref[1];
    var ref1 = (0,react.useReducer)(travelerReducer, {
        adultCount: adultCount,
        childrenCount: childrenCount,
        infantCount: infantCount,
        roomCount: roomCount,
        youthCount: youthCount,
        ages: childrenAges
    }), travelers = ref1[0], setTravelers = ref1[1];
    var isIOS = (0,react.useContext)(BootstrapDataContext/* default */.Z).isIOS;
    (0,react.useEffect)(function() {
        setValue("adultCount", travelers.adultCount, {
            shouldDirty: true
        });
    }, [
        travelers.adultCount,
        setValue
    ]);
    (0,react.useEffect)(function() {
        setValue("childrenAges", travelers.ages, {
            shouldDirty: true
        });
    }, [
        travelers.ages,
        setValue
    ]);
    (0,react.useEffect)(function() {
        setValue("childrenCount", travelers.childrenCount, {
            shouldDirty: true
        });
    }, [
        travelers.childrenCount,
        setValue
    ]);
    (0,react.useEffect)(function() {
        setValue("infantCount", travelers.infantCount, {
            shouldDirty: true
        });
    }, [
        travelers.infantCount,
        setValue
    ]);
    (0,react.useEffect)(function() {
        setValue("youthCount", travelers.youthCount, {
            shouldDirty: true
        });
    }, [
        travelers.youthCount,
        setValue
    ]);
    (0,react.useEffect)(function() {
        setValue("roomCount", travelers.roomCount, {
            shouldDirty: true
        });
    }, [
        travelers.roomCount,
        setValue
    ]);
    var toggleMenu = function(open) {
        return function(e) {
            e.preventDefault();
            if (open) {
                disableShadowState();
            }
            setIsPanelOpen(!open);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickOutsideWrapper/* default */.Z, {
        setIsPanelOpen: function() {
            return disableShadowState();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            "data-testid": "traveler-selection",
            maxWidth: constants/* TRAVELER_SELECTION_CONTAINER_MAX_WIDTH */.Y0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPopover, {
                disabled: disabled,
                color: "background.lightest",
                "data-traveler-selection": "true",
                borderRadius: [
                    "2xl",
                    null,
                    "lg"
                ],
                onDismiss: function() {
                    setIsPanelOpen(!isPanelOpen);
                },
                open: isPanelOpen,
                title: "Traveler Selection",
                width: 1,
                zIndex: isPanelOpen ? 2 : 0,
                isMobile: isMobile,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
                        disabled: disabled,
                        hasError: error.length > 0,
                        isMobile: isMobile,
                        isPanelOpen: isPanelOpen,
                        label: TravelerSelection_renderMenuLabel((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, travelers), {
                            showInfantMenuItem: showInfantMenuItem,
                            showRoomMenuItem: showRoomMenuItem,
                            showYouthMenuItem: showYouthMenuItem
                        })),
                        toggleMenu: toggleMenu
                    }),
                    !isPanelOpen && error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errorTooltipBaseStyles), {
                        children: error
                    })),
                    isPanelOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* Popover.Body */.J2.Body, {
                        color: [
                            "background.light",
                            null,
                            "transparent"
                        ],
                        mt: [
                            0,
                            null,
                            2
                        ],
                        mr: [
                            0,
                            null,
                            -3,
                            0
                        ],
                        openState: isPanelOpen,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuCard, {
                            mt: isIOS ? 2 : 0,
                            boxShadowSize: [
                                "none",
                                null,
                                "overlay-lg"
                            ],
                            color: "background.lightest",
                            "data-testid": "traveler-selection-control-panel",
                            id: "traveler-selection-control-panel",
                            title: "Traveler Selection Menu",
                            width: [
                                1,
                                null,
                                null,
                                null,
                                280
                            ],
                            isMobile: isMobile,
                            borderRadius: [
                                "lg",
                                null,
                                "xl"
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemsPanel, {
                                    hotelPlannerLinkAttrs: hotelPlannerLinkAttrs,
                                    maxAdults: maxAdults,
                                    maxChildren: maxChildren,
                                    maxRooms: maxRooms,
                                    setTravelers: setTravelers,
                                    showInfantMenuItem: showInfantMenuItem,
                                    showRoomMenuItem: showRoomMenuItem,
                                    showSubLabel: showSubLabel,
                                    showYouthMenuItem: showYouthMenuItem,
                                    travelers: travelers
                                }),
                                showChildAgeSelectors && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildAgeSelectors, {
                                    ages: travelers.ages,
                                    childrenCount: childrenCount,
                                    setTravelers: setTravelers,
                                    childAgeSelectors: childAgeSelectors
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                    id: "traveler-selection-done-button",
                                    "data-testid": "traveler-selection-done-button",
                                    onClick: function() {
                                        setIsPanelOpen(false);
                                        onDoneButtonClick();
                                    },
                                    title: "traveler-selection-done-button",
                                    type: "button",
                                    children: "Done"
                                }),
                                disclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    fontSize: 0,
                                    m: 3,
                                    children: disclaimer
                                })
                            ]
                        })
                    })
                ]
            }, "traveler-selection")
        })
    });
}


/***/ }),

/***/ 45588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PO": function() { return /* binding */ FLIGHTS_DISCLAIMER; },
/* harmony export */   "Qz": function() { return /* binding */ subLabels; },
/* harmony export */   "Y0": function() { return /* binding */ TRAVELER_SELECTION_CONTAINER_MAX_WIDTH; },
/* harmony export */   "_D": function() { return /* binding */ MIN_CHILDREN; },
/* harmony export */   "cu": function() { return /* binding */ MIN_ADULTS; },
/* harmony export */   "mn": function() { return /* binding */ MAX_PASSENGERS; },
/* harmony export */   "nK": function() { return /* binding */ MIN_ROOMS; },
/* harmony export */   "p8": function() { return /* binding */ labels; },
/* harmony export */   "sP": function() { return /* binding */ VP_DISCLAIMER; },
/* harmony export */   "yB": function() { return /* binding */ MAX_ROOMS; }
/* harmony export */ });
var MAX_PASSENGERS = 8;
var MAX_ROOMS = 4;
var MIN_ADULTS = 1;
var MIN_CHILDREN = 0;
var MIN_ROOMS = 1;
var TRAVELER_SELECTION_CONTAINER_MAX_WIDTH = 768;
var labels = {
    ADULTS: "Adults",
    CHILDREN: "Children",
    INFANTS: "Infants on lap",
    ROOMS: "Rooms",
    YOUTHS: "Youths"
};
var subLabels = {
    ADULTS: "(ages 18 and up)",
    CHILDREN: "(ages 2-11)",
    INFANTS: "(under 2)",
    ROOMS: "",
    YOUTHS: "(ages 12-17)"
};
var VP_DISCLAIMER = "You may only book a package for up to 8 travelers.";
var FLIGHTS_DISCLAIMER = "You may only book a flight for up to 8 travelers.";


/***/ }),

/***/ 21993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_TypeAhead; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/FormField/FormField.js
var FormField = __webpack_require__(23341);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Label/Label.js
var Label = __webpack_require__(98028);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Input/Input.js
var Input = __webpack_require__(84498);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(86741);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Search.js
var Search = __webpack_require__(72148);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Warning.js
var Warning = __webpack_require__(53666);
// EXTERNAL MODULE: ./node_modules/downshift/dist/downshift.esm.js + 1 modules
var downshift_esm = __webpack_require__(58783);
// EXTERNAL MODULE: ./node_modules/@xstate/react/es/useMachine.js + 9 modules
var useMachine = __webpack_require__(99717);
// EXTERNAL MODULE: ./node_modules/next/dist/build/polyfills/fetch/index.js
var fetch = __webpack_require__(63144);
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);
// EXTERNAL MODULE: ./node_modules/isomorphic-config/lib/config.js
var config = __webpack_require__(82197);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/components/Popover.tsx + 2 modules
var Popover = __webpack_require__(57812);
// EXTERNAL MODULE: ./src/utils/error-helpers.ts
var error_helpers = __webpack_require__(75720);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 238 modules
var es = __webpack_require__(67763);
// EXTERNAL MODULE: ./src/utils/local-forage-helper.ts
var local_forage_helper = __webpack_require__(29735);
;// CONCATENATED MODULE: ./src/hooks/useRecentSearches.ts



function useRecentSearches(key) {
    var ref = (0,react.useState)([]), recentStartLocations = ref[0], setRecentStartLocations = ref[1];
    var ref1 = (0,react.useState)([]), recentEndLocations = ref1[0], setRecentEndLocations = ref1[1];
    var isFlight = key === local_forage_helper/* AIR_SEARCH_DATA */.PP;
    (0,react.useEffect)(function() {
        (0,local_forage_helper/* getPersistedSearchDataByKeys */.xl)([
            key
        ], true).then(function(recentSearches) {
            if (recentSearches) {
                var startLocations = recentSearches.map(function(search) {
                    return isFlight ? search.flights[0].startLocation : search.startLocation;
                }).filter(Boolean);
                var endLocations = recentSearches.map(function(search) {
                    return isFlight ? search.flights[0].endLocation : search.endLocation;
                }).filter(Boolean);
                if (startLocations.length) {
                    setRecentStartLocations((0,es/* uniqWith */.sv7)((0,es/* eqProps */.o5F)("itemName"), startLocations));
                }
                if (endLocations.length) {
                    setRecentEndLocations((0,es/* uniqWith */.sv7)((0,es/* eqProps */.o5F)("itemName"), endLocations));
                }
            }
        });
    }, [
        key,
        isFlight
    ]);
    return [
        recentStartLocations,
        recentEndLocations
    ];
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@pcln/request/dist/esm/index.js
var esm = __webpack_require__(37947);
var esm_default = /*#__PURE__*/__webpack_require__.n(esm);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
;// CONCATENATED MODULE: ./src/hooks/useRecommendations.ts







var cachedRecommendedCityResults = [];
var generateQuery = function(locations) {
    return locations.reduce(function(query, cityId) {
        return "".concat(query, "\n    city_").concat(cityId, ': cityInfo(location: "').concat(cityId, '") {\n        cityName\n        countryCode\n        countryName\n        stateCode\n        stateName\n        latitude\n        longitude\n        itemName: displayCityName\n        lat\n        lon\n        cityID: cityId\n      }');
    }, "");
};
var useRecommendations = function(cityIdList) {
    var shouldFetchCities = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref = (0,react.useState)([]), recommendedCities = ref[0], setRecommendedCities = ref[1];
    (0,react.useEffect)(function() {
        var cancelRequest = false;
        function fetchRecommendations(cityIds) {
            return _fetchRecommendations.apply(this, arguments);
        }
        function _fetchRecommendations() {
            _fetchRecommendations = (0,_async_to_generator/* default */.Z)(function(cityIds) {
                var query, ref, url, timeout, response, _data, errors, data, ref1, error, errorMessage;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (cachedRecommendedCityResults.length > 0) {
                                setRecommendedCities(cachedRecommendedCityResults);
                                return [
                                    2
                                ];
                            }
                            query = generateQuery(cityIds);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            ref = (config_default()).client["pcln-graph"], url = ref.url, timeout = ref.timeout;
                            return [
                                4,
                                esm_default()({
                                    url: url,
                                    timeout: timeout,
                                    method: "POST",
                                    data: {
                                        query: "query { ".concat(query, " }")
                                    }
                                })
                            ];
                        case 2:
                            response = _state.sent();
                            _data = response.data, errors = _data.errors, data = _data.data;
                            if (Array.isArray(errors) && errors.length > 0) {
                                ;
                                analytics/* default.logError */.Z.logError({
                                    message: "Failed to hotelRecommendations api. Error message: ".concat((ref1 = errors[0]) === null || ref1 === void 0 ? void 0 : ref1.message)
                                });
                                return [
                                    2
                                ];
                            }
                            if (data) {
                                cachedRecommendedCityResults = Object.values(data);
                                if (cancelRequest) return [
                                    2
                                ];
                                setRecommendedCities(cachedRecommendedCityResults);
                            }
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            errorMessage = (0,_instanceof/* default */.Z)(error, Error) ? error.message : error.toString();
                            analytics/* default.logError */.Z.logError({
                                message: "Failed to hotelRecommendations api. Error message: ".concat(errorMessage)
                            });
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return _fetchRecommendations.apply(this, arguments);
        }
        if (!shouldFetchCities || (recommendedCities === null || recommendedCities === void 0 ? void 0 : recommendedCities.length) > 0) {
            return;
        }
        if (cityIdList === null || cityIdList === void 0 ? void 0 : cityIdList.cityId.length) {
            fetchRecommendations(cityIdList.cityId.map(function(x) {
                return x.value;
            }));
        }
        return function cleanup() {
            cancelRequest = true;
        };
    }, [
        recommendedCities,
        cityIdList,
        shouldFetchCities
    ]);
    return recommendedCities;
};
/* harmony default export */ var hooks_useRecommendations = (useRecommendations);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/constants/app-routes.ts
var AppRoutes = {
    homepage: "/",
    flights: "/flights",
    hotels: "/hotels",
    vacationpackages: "/vacationpackages",
    vip: "/vip"
};
/* harmony default export */ var app_routes = (AppRoutes);

;// CONCATENATED MODULE: ./src/components/TypeAhead/useTypeAheadForDisplayName.ts



function useTypeAheadForDisplayName() {
    var ref = (0,router.useRouter)(), pathname = ref.pathname, query = ref.query;
    var ref1 = query || {}, tab = ref1.tab, ambigOriginCity = ref1["ambig-origin-city"], ambigDestCity = ref1["ambig-dest-city"];
    var isFlightRoute = pathname === app_routes.flights || tab === "flights";
    var haveCustomItemName = ambigOriginCity || ambigDestCity;
    var itemDisplayNameTransform = function(item) {
        if (item === null) {
            return;
        }
        if (isFlightRoute && item.type === "AIRPORT") {
            var displayNameSegments = [
                item.cityName
            ].concat((0,_to_consumable_array/* default */.Z)((item.countryCode === "US" || item.countryCode === "CA") && item.stateCode ? [
                item.stateCode
            ] : []), (0,_to_consumable_array/* default */.Z)(item.countryCode !== "US" ? [
                item.country
            ] : []));
            return "".concat(displayNameSegments.join(", "), " (").concat(item.id, ")");
        }
        return item.itemName;
    };
    return isFlightRoute && !haveCustomItemName ? itemDisplayNameTransform : null;
}

// EXTERNAL MODULE: ./src/machines/currentLocationMachine.ts
var currentLocationMachine = __webpack_require__(71626);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/SrOnly/SrOnly.js
var SrOnly = __webpack_require__(26795);
;// CONCATENATED MODULE: ./src/constants/dropdown.ts
/**
 * Constants for Dropdown component
 */ var INPUT_MIN_WIDTH = "464px";
/* harmony default export */ var dropdown = (INPUT_MIN_WIDTH);

// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/components/TypeAhead/Dropdown/DropdownCard.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 340px;\n  overflow-y: auto;\n  border-color: transparent;\n  &:focus {\n    outline: none;\n  }\n  ",
        "\n  display: ",
        ";\n  position: absolute;\n  z-index: 2;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var DropdownCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-21ed066a-0"
})(_templateObject(), function(param) {
    var minWidth = param.minWidth;
    return minWidth && "\n    min-width: ".concat(minWidth, ";\n  ");
}, function(props) {
    return props.visible ? "block" : "none";
});
/* harmony default export */ var Dropdown_DropdownCard = (DropdownCard);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./src/components/TypeAhead/FetchTypeAhead.ts
/* eslint-disable react/destructuring-assignment */ 






var _Component;
var FetchTypeAhead = /*#__PURE__*/ function(_superClass) {
    "use strict";
    (0,_inherits/* default */.Z)(FetchTypeAhead, _superClass);
    var _super = (0,_create_super/* default */.Z)(FetchTypeAhead);
    function FetchTypeAhead(props) {
        (0,_class_call_check/* default */.Z)(this, FetchTypeAhead);
        var _this;
        _this = _super.call(this, props);
        _this.mounted = false;
        _this.fetch = debounce_default()(function() {
            if (!_this.mounted) {
                return;
            }
            var _props = _this.props, searchValue = _props.searchValue, typeAheadEndpoint = _props.typeAheadEndpoint;
            if (searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim()) {
                var locationConfig = (config_default()).client.typeahead.location;
                var isRCSearchEndPoint = typeAheadEndpoint === "cars";
                var parsedURLSuffix = isRCSearchEndPoint ? "" : locationConfig.suffix[typeAheadEndpoint];
                var parseURLSuffixQS = isRCSearchEndPoint ? locationConfig.querystring.cars : "";
                var url = "".concat(locationConfig.endpoint[typeAheadEndpoint]).concat(searchValue).concat(parsedURLSuffix).concat(parseURLSuffixQS);
                fetch_default()(url).then(function(res) {
                    return res.json();
                }).then(function(param) {
                    var _searchItems = param.searchItems, searchItems = _searchItems === void 0 ? [] : _searchItems;
                    if (_this.mounted && searchItems) {
                        _this.props.onLoaded();
                        _this.setState({
                            loading: false,
                            items: searchItems
                        });
                    }
                }).catch(function(error) {
                    if (_this.mounted) {
                        _this.props.onLoaded();
                        _this.setState({
                            loading: false,
                            error: error
                        });
                    }
                });
            }
        }, 300);
        _this.state = FetchTypeAhead.initialState;
        return _this;
    }
    var _proto = FetchTypeAhead.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.prepareFetch();
        this.fetch();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.searchValue !== this.props.searchValue || prevProps.searchKey !== this.props.searchKey) {
            this.prepareFetch();
            this.fetch();
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    _proto.prepareFetch = function prepareFetch() {
        this.setState({
            loading: false
        });
    };
    _proto.render = function render() {
        return this.props.render(this.state);
    };
    return FetchTypeAhead;
}(_Component = react.Component);
FetchTypeAhead.initialState = {
    loading: false,
    error: null,
    items: []
};
/* harmony default export */ var TypeAhead_FetchTypeAhead = (FetchTypeAhead);

// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Cars.js
var Cars = __webpack_require__(70895);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Pin.js
var Pin = __webpack_require__(28387);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Flights.js
var Flights = __webpack_require__(98611);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/CityView.js
var CityView = __webpack_require__(74330);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils = __webpack_require__(67113);
;// CONCATENATED MODULE: ./src/components/TypeAhead/Dropdown/DropdownItem.tsx




function DropdownItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  cursor: pointer;\n  align-items: center;\n\n  &:hover {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n\n  &:focus {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    DropdownItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function FlexContainer(_param) {
    var className = _param.className, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        borderRadius: "lg",
        m: 0,
        role: "option",
        width: 1
    }, rest), {
        children: children
    }));
}
var DropdownItem = (0,styled_components_browser_esm/* default */.ZP)(FlexContainer).withConfig({
    componentId: "sc-e7a6696f-0"
})(DropdownItem_templateObject(), function(props) {
    return props.isHighlighted ? (0,utils/* getPaletteColor */.ow)("background.base") : null;
}, function(props) {
    return props.isHighlighted ? (0,utils/* getPaletteColor */.ow)("text.base") : null;
}, function(props) {
    return props.isHighlighted ? (0,utils/* getPaletteColor */.ow)("background.base") : null;
}, function(props) {
    return props.isHighlighted ? (0,utils/* getPaletteColor */.ow)("text.base") : null;
}, (0,utils/* getPaletteColor */.ow)("background.base"), (0,utils/* getPaletteColor */.ow)("text.base"));
/* harmony default export */ var Dropdown_DropdownItem = (DropdownItem);

;// CONCATENATED MODULE: ./src/components/TypeAhead/Dropdown/SearchItem.tsx







function SearchItem(param) {
    var isItemSelected = param.isItemSelected, index = param.index, getItemProps = param.getItemProps, item = param.item, _gaTracking = param.gaTracking, gaTracking = _gaTracking === void 0 ? function() {
    // leave blank to prevent error if no tracking provided
    } : _gaTracking, isMobile = param.isMobile;
    var iconName = item.type;
    var iconDesc = "".concat(iconName, "-").concat(index);
    var ICONS = {
        PARTNER_LOC: Cars/* default */.Z,
        POI: Pin/* default */.Z,
        AIRPORT: Flights/* default */.Z,
        CITY: CityView/* default */.Z
    };
    var _iconName;
    var Icon = (_iconName = ICONS[iconName]) !== null && _iconName !== void 0 ? _iconName : Pin/* default */.Z;
    var displayText = item.itemName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown_DropdownItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isHighlighted: isItemSelected
    }, getItemProps({
        item: item,
        index: index,
        onClick: function() {
            gaTracking();
        }
    })), {
        isMobile: isMobile,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                color: "primary",
                mx: 2,
                "aria-label": iconName,
                desc: iconName,
                descId: iconDesc,
                title: iconName,
                titleId: iconDesc,
                size: 24
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                textStyle: "subheading5",
                py: 3,
                mr: 2,
                role: "option",
                "aria-selected": isItemSelected,
                children: displayText
            })
        ]
    }));
}
/* harmony default export */ var Dropdown_SearchItem = (SearchItem);

// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Gps.js
var Gps = __webpack_require__(25792);
;// CONCATENATED MODULE: ./src/components/TypeAhead/Dropdown/RenderCurrentLocation.tsx





var renderDisplayText = function(current) {
    if (current.matches("pending")) {
        return "Locating...";
    }
    if (current.matches("rejected")) {
        if (current.context.error) {
            return "Having Issue Locating, Please try again";
        }
        return "Location Sharing Disabled";
    }
    return "Use Current Location";
};
function RenderCurrentLocation(param) {
    var handleRequestCurrentLocationClick = param.handleRequestCurrentLocationClick, current = param.current;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown_DropdownItem, {
        onMouseDown: handleRequestCurrentLocationClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Gps/* default */.Z, {
                color: "primary",
                mx: 2,
                size: 24
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                textStyle: "subheading5",
                py: 3,
                mr: 2,
                children: renderDisplayText(current)
            })
        ]
    });
}
/* harmony default export */ var Dropdown_RenderCurrentLocation = (RenderCurrentLocation);

;// CONCATENATED MODULE: ./src/components/TypeAhead/Dropdown/RenderRecentSearches.tsx






function RenderRecentSearches(param) {
    var getItemProps = param.getItemProps, highlightedIndex = param.highlightedIndex, recentSearches = param.recentSearches, gaTracking = param.gaTracking, recentOrRecommendationTitle = param.recentOrRecommendationTitle, isMobile = param.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                fontSize: 0,
                p: 2,
                fontWeight: "bold",
                children: recentOrRecommendationTitle
            }),
            recentSearches.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown_SearchItem, {
                    isItemSelected: index === highlightedIndex,
                    index: index,
                    item: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        skipFeedbackCall: true
                    }),
                    getItemProps: getItemProps,
                    gaTracking: gaTracking,
                    isMobile: isMobile
                }, item.id);
            })
        ]
    });
}
/* harmony default export */ var Dropdown_RenderRecentSearches = (RenderRecentSearches);

;// CONCATENATED MODULE: ./src/components/TypeAhead/Dropdown/index.tsx














function Dropdown(param) {
    var isOpen = param.isOpen, highlightedIndex = param.highlightedIndex, getItemProps = param.getItemProps, getMenuProps = param.getMenuProps, searchKey = param.searchKey, searchValue = param.searchValue, clearItems = param.clearItems, current = param.current, _handleRequestCurrentLocationClick = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    handleRequestCurrentLocationClick, handleRequestCurrentLocationClick = _handleRequestCurrentLocationClick === void 0 ? function() {} : _handleRequestCurrentLocationClick, _showCurrentLocation = param.showCurrentLocation, showCurrentLocation = _showCurrentLocation === void 0 ? false : _showCurrentLocation, setHighlightedIndex = param.setHighlightedIndex, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, typeAheadEndpoint = param.typeAheadEndpoint, _recentSearches = param.recentSearches, recentSearches = _recentSearches === void 0 ? [] : _recentSearches, _label = param.label, label = _label === void 0 ? "" : _label, recentOrRecommendationTitle = param.recentOrRecommendationTitle;
    var pathname = (0,router.useRouter)().pathname;
    var isHomepage = pathname === "/";
    var isFlightOrHotelTab = typeAheadEndpoint === "flights" || typeAheadEndpoint === "hotels";
    var gaLabel = label.includes("to") ? "going to" : "departing";
    return isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead_FetchTypeAhead, {
        searchValue: searchValue,
        searchKey: searchKey,
        typeAheadEndpoint: typeAheadEndpoint,
        onLoaded: function() {
            clearItems();
            setHighlightedIndex(0);
        },
        render: function(param) {
            var items = param.items;
            var isCardVisible = isOpen && items.length;
            var isRecentSearchesVisible = isOpen && recentSearches.length && searchValue === "";
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    isCardVisible > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SrOnly/* default */.Z, {
                        "aria-live": "polite",
                        children: [
                            items.length,
                            " number of results"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown_DropdownCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        boxShadowSize: !isMobile && "overlay-lg",
                        "data-testid": "typeahead-dropdown-card",
                        color: "background.lightest",
                        borderRadius: "xl",
                        p: isMobile ? 0 : 2,
                        mt: isMobile ? 0 : 1,
                        pr: isMobile ? 4 : undefined,
                        role: "listbox",
                        rounded: isMobile ? "bottom" : "",
                        width: 1,
                        minWidth: isMobile ? "" : dropdown,
                        visible: isCardVisible || isRecentSearchesVisible || showCurrentLocation
                    }, getMenuProps({
                        refKey: "ref",
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        isOpen: isOpen
                    })), {
                        children: [
                            showCurrentLocation && current && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown_RenderCurrentLocation, {
                                current: current,
                                handleRequestCurrentLocationClick: handleRequestCurrentLocationClick
                            }),
                            isRecentSearchesVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown_RenderRecentSearches, {
                                isMobile: isMobile,
                                getItemProps: getItemProps,
                                recentSearches: recentSearches,
                                highlightedIndex: highlightedIndex,
                                recentOrRecommendationTitle: recentOrRecommendationTitle,
                                gaTracking: function() {
                                    return isHomepage && isFlightOrHotelTab ? analytics/* default.fireEvent */.Z.fireEvent({
                                        category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
                                        action: "".concat(typeAheadEndpoint, " ").concat(recentOrRecommendationTitle.toLowerCase()),
                                        label: gaLabel
                                    }) : undefined;
                                }
                            }) : null,
                            isCardVisible ? items.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown_SearchItem, {
                                    isMobile: isMobile,
                                    isItemSelected: index === highlightedIndex,
                                    index: index,
                                    item: item,
                                    getItemProps: getItemProps
                                }, item.itemName);
                            }) : null
                        ]
                    }))
                ]
            });
        }
    }) : null;
}
/* harmony default export */ var TypeAhead_Dropdown = (Dropdown);

;// CONCATENATED MODULE: ./src/components/TypeAhead/StyledInput.ts
var checkLabelLargerInput = function(label) {
    return label ? {
        height: "56px",
        paddingTop: "18px",
        paddingBottom: "10px"
    } : {
        height: "56px"
    };
};
var setLargerInput = function(value, label) {
    return value ? checkLabelLargerInput(label) : {
        height: "56px",
        paddingTop: "14px",
        paddingBottom: "14px"
    };
};
var typeAheadInputStyle = function(value, label) {
    return setLargerInput(value, label);
};
/* harmony default export */ var StyledInput = (typeAheadInputStyle);

;// CONCATENATED MODULE: ./src/components/TypeAhead/index.tsx






















// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function() {};
var errorProps = {
    id: "typeahead-error",
    style: {
        zIndex: 1
    },
    bottom: true,
    right: true,
    color: "error",
    role: "alert"
};
var mapTypeToCode = {
    AIRPORT: "A",
    CITY: "C",
    HOTEL: "H",
    POI: "P",
    GEO: "GEO",
    LATLON: "LATLON",
    PARTNER_LOC: "PARTNER_LOC",
    GDS_CITY: "GDS_CITY"
};
var recentSearchesKey = {
    cars: local_forage_helper/* CAR_SEARCH_DATA */.xj,
    hotels: local_forage_helper/* HOTEL_SEARCH_DATA */.yO,
    flights: local_forage_helper/* AIR_SEARCH_DATA */.PP,
    packagesOrigin: local_forage_helper/* PACKAGE_SEARCH_DATA */.Tw,
    packagesDestination: local_forage_helper/* PACKAGE_SEARCH_DATA */.Tw
};
var TypeAhead = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var label = param.label, placeholder = param.placeholder, searchProduct = param.searchProduct, searchKey = param.searchKey, _setValue = param.setValue, setValue = _setValue === void 0 ? noop : _setValue, defaultSelectedItem = param.defaultSelectedItem, errors = param.errors, disableShadowState = param.disableShadowState, _focusNextElement = param.focusNextElement, focusNextElement = _focusNextElement === void 0 ? noop : _focusNextElement, _onItemSelect = param.onItemSelect, onItemSelect = _onItemSelect === void 0 ? noop : _onItemSelect, _showCurrentLocation = param.showCurrentLocation, showCurrentLocation = _showCurrentLocation === void 0 ? false : _showCurrentLocation;
    var ref1;
    var ref2 = (0,react.useContext)(BootstrapDataContext/* default */.Z), isMobile = ref2.isMobile, key = ref2.key, recommendedCityIds = ref2.recommendedCityIds, signedIn = ref2.signInStatus.signedIn;
    var handleInputKeyDown = function(param) {
        var event = param.event, isOpen = param.isOpen, selectHighlightedItem = param.selectHighlightedItem;
        if (isOpen && [
            "Tab"
        ].includes(event.key)) {
            event.preventDefault();
            selectHighlightedItem();
            focusNextElement();
        }
    };
    var typeAheadEndpoint = searchProduct;
    var currentRecentSearchesKey = recentSearchesKey[typeAheadEndpoint];
    var ref3 = (0,_sliced_to_array/* default */.Z)(useRecentSearches(currentRecentSearchesKey), 2), recentStartLocations = ref3[0], recentEndLocations = ref3[1];
    var recentSearches = searchKey.includes("startLocation") ? recentStartLocations : recentEndLocations;
    var handleTypeAheadFeedback = function(param) {
        var entered = param.entered, id = param.id, itemName = param.itemName, displayName = param.displayName, type = param.type, selectedPosition = param.selectedPosition, skipFeedbackCall = param.skipFeedbackCall;
        if (skipFeedbackCall) return;
        // swagger for feedback call api http://ny-htlindex-001:8080/typeahead/index/swagger-ui.html#/feedback-controller/typeaheadFeedbackWithSelectedPositionUsingGET
        var url = "".concat((config_default()).client.typeahead.feedback[typeAheadEndpoint], "/").concat(id, "/").concat(encodeURIComponent(entered), "/").concat(encodeURIComponent(itemName || displayName || ""), "/").concat(selectedPosition !== null && selectedPosition !== void 0 ? selectedPosition : "");
        var queryParams = "language=en&locale=en-US&placeType=".concat(mapTypeToCode[type]);
        fetch_default()("".concat(url, "?").concat(queryParams));
    };
    var ref4 = (0,react.useState)(false), isPopoverOpen = ref4[0], setIsPopoverOpen = ref4[1];
    var handleSelect = function(disableShadowEffect) {
        return function(selectedItem, param) {
            var reset = param.reset, highlightedIndex = param.highlightedIndex;
            setValue(searchKey, selectedItem, {
                shouldDirty: true
            });
            onItemSelect(selectedItem);
            reset();
            if (selectedItem) {
                handleTypeAheadFeedback((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedItem), {
                    selectedPosition: highlightedIndex
                }));
                disableShadowEffect();
                setIsPopoverOpen(false);
            }
        };
    };
    var stateReducer = function(state, changes) {
        switch(changes.type){
            case downshift_esm/* default.stateChangeTypes.keyDownEnter */.ZP.stateChangeTypes.keyDownEnter:
            case downshift_esm/* default.stateChangeTypes.clickItem */.ZP.stateChangeTypes.clickItem:
            case downshift_esm/* default.stateChangeTypes.mouseUp */.ZP.stateChangeTypes.mouseUp:
            case undefined:
            case downshift_esm/* default.stateChangeTypes.unknown */.ZP.stateChangeTypes.unknown:
                {
                    var highlightedIndex = state.highlightedIndex, inputValue = state.inputValue;
                    if (state.isOpen && Object.prototype.hasOwnProperty.call(changes, "isOpen")) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, changes), {
                            // persist value of highlightedIndex after item selection
                            // Normally highlightedIndex changes to defaultHighlightedIndex after selection
                            highlightedIndex: highlightedIndex,
                            inputValue: inputValue
                        });
                    }
                    return changes;
                }
            default:
                return changes;
        }
    };
    var itemDisplayNameTransform = useTypeAheadForDisplayName();
    var itemToString = function(i) {
        var ref, ref1;
        return (ref1 = (ref = itemDisplayNameTransform === null || itemDisplayNameTransform === void 0 ? void 0 : itemDisplayNameTransform(i)) !== null && ref !== void 0 ? ref : i === null || i === void 0 ? void 0 : i.itemName) !== null && ref1 !== void 0 ? ref1 : "";
    };
    var errorMessage = (0,error_helpers/* getErrorFromKey */.Ux)(searchKey)(errors);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useMachine/* useMachine */.e)(currentLocationMachine/* default */.Z), 3), current = ref5[0], send = ref5[1], service = ref5[2];
    var currentLocationProps = {
        current: current,
        showCurrentLocation: showCurrentLocation,
        handleRequestCurrentLocationClick: function() {
            send("REQUEST");
        }
    };
    (0,react.useEffect)(function() {
        var subscription = service.subscribe(function(state) {
            if (state.matches("resolved")) {
                disableShadowState();
                setValue(searchKey, state.context.cityData, {
                    shouldDirty: true
                });
                onItemSelect(state.context.cityData);
                setIsPopoverOpen(false);
            }
        });
        return function() {
            return subscription.unsubscribe();
        };
    }, [
        service,
        setValue,
        searchKey,
        onItemSelect,
        disableShadowState
    ]);
    var isHotelTypeaheadOnHP = typeAheadEndpoint === "hotels" && key === "home";
    var canDisplayRecommendations = isHotelTypeaheadOnHP && signedIn && recommendedCityIds && (recommendedCityIds === null || recommendedCityIds === void 0 ? void 0 : (ref1 = recommendedCityIds.cityId) === null || ref1 === void 0 ? void 0 : ref1.length) > 0;
    var ref6 = (0,react.useState)([]), recentOrRecommendationData = ref6[0], setRecentOrRecommendationData = ref6[1];
    var ref7 = (0,react.useState)(""), recentOrRecommendationTitle = ref7[0], setRecentOrRecommendationTitle = ref7[1];
    var recommendedSearches = hooks_useRecommendations(recommendedCityIds, canDisplayRecommendations);
    (0,react.useEffect)(function() {
        if (canDisplayRecommendations) {
            setRecentOrRecommendationData(recommendedSearches);
            setRecentOrRecommendationTitle("Recommended Searches");
        } else {
            setRecentOrRecommendationData(recentSearches);
            setRecentOrRecommendationTitle("Recent Searches");
        }
    }, [
        recommendedCityIds,
        recommendedSearches,
        recentSearches,
        canDisplayRecommendations
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(downshift_esm/* default */.ZP, {
        stateReducer: stateReducer,
        selectedItem: defaultSelectedItem,
        defaultHighlightedIndex: 0,
        onSelect: handleSelect(disableShadowState),
        itemToString: itemToString,
        id: "".concat(searchKey, "-typeahead-downshift-container"),
        children: function(_param) /*#__PURE__*/ {
            var getLabelProps = _param.getLabelProps, getInputProps = _param.getInputProps, getRootProps = _param.getRootProps, openMenu = _param.openMenu, clearSelection = _param.clearSelection, selectHighlightedItem = _param.selectHighlightedItem, isOpen = _param.isOpen, inputValue = _param.inputValue, highlightedIndex = _param.highlightedIndex, restProps = (0,_object_without_properties/* default */.Z)(_param, [
                "getLabelProps",
                "getInputProps",
                "getRootProps",
                "openMenu",
                "clearSelection",
                "selectHighlightedItem",
                "isOpen",
                "inputValue",
                "highlightedIndex"
            ]);
            return (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                width: 1,
                style: {
                    position: "relative"
                }
            }, getRootProps({
                refKey: "ref"
            })), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                    open: isPopoverOpen,
                    top: 8,
                    onDismiss: function() {
                        return setIsPopoverOpen(false);
                    },
                    isMobile: isMobile,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            role: "combobox",
                            "aria-expanded": isOpen ? "true" : "false",
                            "aria-owns": "typeahead-list",
                            "aria-haspopup": "listbox",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormField/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            pb: 0,
                                            autoHide: label === placeholder,
                                            width: "auto"
                                        }, getLabelProps()), {
                                            children: label
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                                            color: "primary",
                                            size: 24
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, (0,_object_spread/* default */.Z)({
                                            color: errorMessage ? "red" : undefined,
                                            ref: ref,
                                            borderRadius: "lg",
                                            id: "".concat(searchKey, "-typeahead-input"),
                                            "data-testid": "".concat(searchKey, "-typeahead-input"),
                                            autoComplete: "off"
                                        }, getInputProps({
                                            placeholder: placeholder,
                                            name: searchKey,
                                            style: StyledInput(inputValue, label),
                                            isOpen: isOpen,
                                            onKeyDown: function(event) {
                                                handleInputKeyDown({
                                                    event: event,
                                                    selectHighlightedItem: selectHighlightedItem,
                                                    isOpen: isOpen
                                                });
                                                setIsPopoverOpen(true);
                                            },
                                            onKeyUp: function(event) {
                                                if (event.key === "Escape") {
                                                    setIsPopoverOpen(false);
                                                }
                                            },
                                            onChange: function(event) {
                                                if (event.target.value === "") {
                                                    clearSelection();
                                                }
                                            },
                                            onClick: function(event) {
                                                event.preventDefault();
                                                var target = event.target;
                                                if (target.value !== "") {
                                                    target.select();
                                                    openMenu();
                                                }
                                                setIsPopoverOpen(true);
                                            },
                                            onBlur: function() {
                                                setIsPopoverOpen(false);
                                            },
                                            onFocus: function(event) {
                                                if (showCurrentLocation || recentOrRecommendationData.length || event.target.value !== "") {
                                                    openMenu();
                                                }
                                                setIsPopoverOpen(true);
                                            }
                                        }))),
                                        errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {
                                            color: "error",
                                            size: 20
                                        })
                                    ]
                                }),
                                errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, errorProps), {
                                    children: errorMessage
                                })),
                                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead_Dropdown, (0,_object_spread/* default */.Z)({
                                    isOpen: isOpen,
                                    searchKey: searchKey,
                                    searchValue: inputValue,
                                    isMobile: isMobile,
                                    typeAheadEndpoint: typeAheadEndpoint,
                                    highlightedIndex: highlightedIndex,
                                    recentSearches: recentOrRecommendationData,
                                    recentOrRecommendationTitle: recentOrRecommendationTitle,
                                    label: label
                                }, restProps))
                            ]
                        }),
                        isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead_Dropdown, (0,_object_spread/* default */.Z)({
                            isOpen: isOpen,
                            searchKey: searchKey,
                            searchValue: inputValue,
                            isMobile: isMobile,
                            typeAheadEndpoint: typeAheadEndpoint,
                            highlightedIndex: highlightedIndex,
                            recentSearches: recentOrRecommendationData,
                            recentOrRecommendationTitle: recentOrRecommendationTitle,
                            label: label
                        }, currentLocationProps, restProps))
                    ]
                })
            }));
        }
    });
});
/* harmony default export */ var components_TypeAhead = (TypeAhead);


/***/ }),

/***/ 66487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bd": function() { return /* binding */ ANALYTICS_CATEGORY_PACKAGES; },
/* harmony export */   "DG": function() { return /* binding */ ANALYTICS_CATEGORY_HOME; },
/* harmony export */   "T": function() { return /* binding */ ANALYTICS_CATEGORY_HOTELS; },
/* harmony export */   "UI": function() { return /* binding */ INVALID; },
/* harmony export */   "Yz": function() { return /* binding */ ANALYTICS_CATEGORY_VIP_LANDING; },
/* harmony export */   "ZP": function() { return /* binding */ ANALYTICS_CATEGORIES; },
/* harmony export */   "h0": function() { return /* binding */ ANALYTICS_ACTION_HOTELS_SEARCH; },
/* harmony export */   "tu": function() { return /* binding */ ANALYTICS_ACTION_FLIGHTS_SEARCH; },
/* harmony export */   "y1": function() { return /* binding */ ANALYTICS_CATEGORY_FLIGHTS; }
/* harmony export */ });
/* unused harmony exports ANALYTICS_CUSTOM_EVENT, VALID */
var ANALYTICS_ACTION_FLIGHTS_SEARCH = "Flight Search Button";
var ANALYTICS_ACTION_HOTELS_SEARCH = "Hotel Search Button";
var ANALYTICS_CATEGORY_FLIGHTS = "FLIGHT_HOME";
var ANALYTICS_CATEGORY_HOME = "PCLN_HOME";
var ANALYTICS_CATEGORY_HOTELS = "HOTEL_HOME";
var ANALYTICS_CATEGORY_PACKAGES = "PACKAGES_HOME";
var ANALYTICS_CATEGORY_VIP_LANDING = "vip_landing";
var ANALYTICS_CUSTOM_EVENT = "gtm-custom-event";
var INVALID = "Invalid";
var VALID = "Valid";
var ANALYTICS_CATEGORIES = {
    "/": ANALYTICS_CATEGORY_HOME,
    "/flights": ANALYTICS_CATEGORY_FLIGHTS,
    "/hotels": ANALYTICS_CATEGORY_HOTELS,
    "/vacationpackages": ANALYTICS_CATEGORY_PACKAGES
};


/***/ }),

/***/ 78474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTabGroup; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82670);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function useTabGroup() {
    var registerTabElement = function registerTabElement(ref) {
        if (ref) {
            tabElements.current.add(ref);
        }
    };
    var tabElements = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new Set());
    var focusNextElement = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var elementList = Array.from(tabElements.current);
        if (!document) {
            return;
        }
        var activeElement = document.activeElement;
        if (activeElement && ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(activeElement, HTMLInputElement) || (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(activeElement, HTMLSelectElement))) {
            var selectedItemIndex = elementList.indexOf(activeElement);
            if (selectedItemIndex === -1 || selectedItemIndex + 1 >= elementList.length) {
                return setTimeout(function() {
                    return elementList[0].focus();
                }, 0);
            }
            return setTimeout(function() {
                return elementList[selectedItemIndex + 1].focus();
            }, 0);
        }
    }, []);
    return {
        registerTabElement: registerTabElement,
        focusNextElement: focusNextElement
    };
}


/***/ }),

/***/ 71626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ invokeFetchCurrentCityData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70655);
/* harmony import */ var xstate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4723);
/* harmony import */ var xstate__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62494);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63144);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var isomorphic_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82197);
/* harmony import */ var isomorphic_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94738);






function isGeoServiceResponseSuccessful(responseData) {
    return responseData.exactMatch !== undefined;
}
function invokeFetchCurrentCityData(latitude, longitude) {
    return _invokeFetchCurrentCityData.apply(this, arguments);
}
function _invokeFetchCurrentCityData() {
    _invokeFetchCurrentCityData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(latitude, longitude) {
        var url, res, data, _searchedLocation, lat, lon, _exactMatch, cityID, displayText, errorMessage;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = "".concat((isomorphic_config__WEBPACK_IMPORTED_MODULE_1___default().client.search.retail.hotels), "geo/").concat(latitude, "/").concat(longitude, "/5?version=1");
                    return [
                        4,
                        isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_0___default()(url)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    data = _state.sent();
                    if (isGeoServiceResponseSuccessful(data)) {
                        if (data.exactMatch !== null && data.searchedLocation !== null) {
                            _searchedLocation = data.searchedLocation, lat = _searchedLocation.lat, lon = _searchedLocation.lon;
                            _exactMatch = data.exactMatch, cityID = _exactMatch.matchedCity.cityID, displayText = _exactMatch.displayText;
                            if (lat !== undefined && lon !== undefined && displayText) {
                                return [
                                    2,
                                    {
                                        itemName: displayText,
                                        content: displayText,
                                        type: "GEO",
                                        lat: lat,
                                        lon: lon,
                                        cityID: cityID.toString()
                                    }
                                ];
                            }
                        }
                        throw new Error("No city was matched for this latitude/longitude.");
                    }
                    errorMessage = "Result code: ".concat(data.resultCode, ", rguid: ").concat(data.rguid, ", message: ").concat(data.resultMessage);
                    _shared_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].logError */ .Z.logError({
                        message: errorMessage
                    });
                    throw new Error(errorMessage);
            }
        });
    });
    return _invokeFetchCurrentCityData.apply(this, arguments);
}
function geoService() {
    return function(cb) {
        if (!navigator.geolocation) {
            cb({
                type: "error",
                error: new Error("Geolocation is not supported")
            });
            return;
        }
        var geoWatch = navigator.geolocation.watchPosition(// sends back to parent
        function(position) {
            return cb({
                type: "success",
                position: position
            });
        }, function(error) {
            return cb({
                type: "error",
                error: error
            });
        });
        // disposal function
        return function() {
            return navigator.geolocation.clearWatch(geoWatch);
        };
    };
}
var shouldRequest = function(context) {
    return context.cityData === null;
};
var currentLocationMachine = (0,xstate__WEBPACK_IMPORTED_MODULE_5__/* .createMachine */ .C)({
    id: "geo",
    context: {
        error: null,
        cityData: null,
        position: null
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                REQUEST: [
                    {
                        target: "pending",
                        cond: shouldRequest
                    },
                    {
                        target: "resolved"
                    }
                ]
            }
        },
        pending: {
            invoke: {
                src: geoService
            },
            on: {
                success: {
                    target: "gettingCurrentCity",
                    actions: (0,xstate__WEBPACK_IMPORTED_MODULE_6__/* .assign */ .f0)({
                        position: function(_, event) {
                            return event.position;
                        }
                    })
                },
                error: {
                    target: "rejected",
                    actions: (0,xstate__WEBPACK_IMPORTED_MODULE_6__/* .assign */ .f0)({
                        error: function(_, event) {
                            return event.error;
                        }
                    })
                }
            }
        },
        gettingCurrentCity: {
            invoke: {
                src: function(context) {
                    var ref, ref1;
                    return context.position !== null ? invokeFetchCurrentCityData((ref = context.position) === null || ref === void 0 ? void 0 : ref.coords.latitude, (ref1 = context.position) === null || ref1 === void 0 ? void 0 : ref1.coords.longitude) : Promise.reject();
                },
                onDone: {
                    target: "resolved",
                    actions: (0,xstate__WEBPACK_IMPORTED_MODULE_6__/* .assign */ .f0)({
                        cityData: function(_, event) {
                            return event.data;
                        }
                    })
                },
                onError: {
                    target: "rejected",
                    actions: (0,xstate__WEBPACK_IMPORTED_MODULE_6__/* .assign */ .f0)({
                        error: function(_, event) {
                            return event.data;
                        }
                    })
                }
            }
        },
        resolved: {},
        rejected: {}
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (currentLocationMachine);


/***/ }),

/***/ 94738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51438);
/* harmony import */ var _pcln_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41525);
/* harmony import */ var _constants_analytics__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66487);
/* eslint-disable class-methods-use-this */ 


var Analytics = /*#__PURE__*/ function() {
    "use strict";
    function Analytics() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Analytics);
    }
    var _proto = Analytics.prototype;
    // Log to both GA and Splunk
    _proto.fireEvent = function fireEvent(param) {
        var _category = param.category, category = _category === void 0 ? _constants_analytics__WEBPACK_IMPORTED_MODULE_0__/* .ANALYTICS_CATEGORY_PACKAGES */ .Bd : _category, _action = param.action, action = _action === void 0 ? "" : _action, _data = param.data, data = _data === void 0 ? "" : _data, _event = param.event, event = _event === void 0 ? "" : _event, _label = param.label, label = _label === void 0 ? "" : _label;
        _pcln_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].logEvent */ .Z.logEvent({
            action: action,
            category: category,
            data: data,
            event: event,
            label: label
        });
    };
    // Log an error
    // sample query 'index=cheetah sourcetype=ESBROWSEREVENTDATA_ESSVCS action=Error'
    _proto.logError = function logError(param) {
        var _message = param.message, message = _message === void 0 ? "" : _message;
        _pcln_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].logError */ .Z.logError({
            message: message
        });
    };
    // Log directly to Splunk
    // sample query 'index=cheetah sourcetype=ESBROWSEREVENTDATA_ESSVCS action=Log'
    _proto.log = function log(param) {
        var _message = param.message, message = _message === void 0 ? "" : _message;
        _pcln_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].log */ .Z.log({
            message: message
        });
    };
    // Log a warning
    // sample query 'index=cheetah sourcetype=ESBROWSEREVENTDATA_ESSVCS action=warning'
    _proto.logWarning = function logWarning(param) {
        var _name = param.name, name = _name === void 0 ? "" : _name, _message = param.message, message = _message === void 0 ? "" : _message;
        _pcln_analytics__WEBPACK_IMPORTED_MODULE_2__/* ["default"].logWarning */ .Z.logWarning({
            name: name,
            message: message
        });
    };
    return Analytics;
}();
/* harmony default export */ __webpack_exports__["Z"] = (new Analytics());


/***/ }),

/***/ 68511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D$": function() { return /* binding */ getRcMinDate; },
/* harmony export */   "G4": function() { return /* binding */ defaultToday; },
/* harmony export */   "Q0": function() { return /* binding */ getPackagesDateRange; },
/* harmony export */   "U6": function() { return /* binding */ getRcMaxDate; },
/* harmony export */   "Vo": function() { return /* binding */ defaultMaxDate; },
/* harmony export */   "Y_": function() { return /* binding */ getDateRange; },
/* harmony export */   "Zx": function() { return /* binding */ defaultTomorrow; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "r2": function() { return /* binding */ addFormattedDays; },
/* harmony export */   "vD": function() { return /* binding */ getHotelDateRange; },
/* harmony export */   "wU": function() { return /* binding */ getTimeOptions; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42298);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35337);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77349);



var formatDate = function(dateStr) {
    var dateFormat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "MM/dd/yyyy";
    var formatedDate = "";
    try {
        if (dateStr) {
            formatedDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dateStr, "yyyyMMdd", new Date()), dateFormat);
        }
    } catch (err) {
        formatedDate = "";
    }
    return formatedDate;
};
var addFormattedDays = function(dateStr, days) {
    var dateFormat = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "yyyyMMdd";
    if (dateStr) {
        return (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dateStr, "yyyyMMdd", new Date()), days), dateFormat);
    }
    return "";
};
var now = Date.now();
var defaultToday = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(now, "yyyyMMdd");
var defaultTomorrow = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(now, 1), "yyyyMMdd");
var defaultMaxDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(now, 330), "yyyyMMdd");
// Shared methods for Flights, SOPQ Flights and RC
/**
 * @param {object} param0
 * @param {string | null} [param0.departureDate]
 * @param {string | null} [param0.arrivalDate] - The name of the employee.
 * @param {boolean} isOneWay
 */ var getDateRange = function(param, isOneWay) {
    var _departureDate = param.departureDate, departureDate = _departureDate === void 0 ? null : _departureDate, _arrivalDate = param.arrivalDate, arrivalDate = _arrivalDate === void 0 ? null : _arrivalDate;
    if (!departureDate) return "";
    var start = formatDate(departureDate);
    if (isOneWay) return start;
    var end = formatDate(arrivalDate);
    return "".concat(start, " – ").concat(end);
};
var getPackagesDateRange = function(param) {
    var startDate = param.startDate, endDate = param.endDate;
    if (!startDate) return "";
    return "".concat(formatDate(startDate), " - ").concat(formatDate(endDate));
};
var getHotelDateRange = function(param) {
    var startDate = param.startDate, endDate = param.endDate;
    if (!startDate && !endDate) return "";
    var start = formatDate(startDate);
    var end = formatDate(endDate);
    return [
        start,
        end
    ].join(" – ");
};
var getRcMinDate = function(pickupDate) {
    if (pickupDate) {
        return formatDate(pickupDate, "yyyyMMdd");
    }
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new Date(), "yyyyMMdd");
};
var getRcMaxDate = function(dropoffDate) {
    if (dropoffDate) {
        return formatDate(dropoffDate, "yyyyMMdd");
    }
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new Date(), 330), "yyyyMMdd");
};
var getTimeOptions = function() {
    var times = new Array(48).fill(null).map(function(_, i) {
        return i;
    });
    return times.map(function(time) {
        var date = new Date(0, 0, 0, Math.floor(time / 2), time % 2 === 0 ? 0 : 30);
        var value = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(date, "HH:mm");
        var label = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(date, "h:mm a");
        if (value === "00:00") {
            label = "Midnight";
        } else if (value === "12:00") {
            label = "Noon";
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
            value: value,
            children: label
        }, value);
    });
};


/***/ }),

/***/ 75720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mx": function() { return /* binding */ getDateFieldBorderColors; },
/* harmony export */   "Q4": function() { return /* binding */ getDateFieldErrorMessage; },
/* harmony export */   "Ux": function() { return /* binding */ getErrorFromKey; }
/* harmony export */ });
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67763);
/* eslint import/prefer-default-export: 0 */ 
var getErrorFromKey = (0,ramda__WEBPACK_IMPORTED_MODULE_0__/* .compose */ .qCK)(ramda__WEBPACK_IMPORTED_MODULE_0__/* .path */ .ETc, (0,ramda__WEBPACK_IMPORTED_MODULE_0__/* .append */ .R3I)("message"), (0,ramda__WEBPACK_IMPORTED_MODULE_0__/* .split */ .Vl2)("."));
var getDateFieldBorderColors = function(errors, i) {
    var ref, ref1;
    return ((ref = errors.flights) === null || ref === void 0 ? void 0 : (ref1 = ref[i]) === null || ref1 === void 0 ? void 0 : ref1.startDate) ? "red" : undefined;
};
var getDateFieldErrorMessage = function(errors, i) {
    var isRoundTripFlight = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref, ref1, ref2, ref3, ref4, ref5;
    // eslint-disable-next-line no-nested-ternary
    return ((ref = errors.flights) === null || ref === void 0 ? void 0 : (ref1 = ref[i]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.startDate) === null || ref2 === void 0 ? void 0 : ref2.message) || ((ref3 = errors.flights) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[i]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.endDate) === null || ref5 === void 0 ? void 0 : ref5.message) ? isRoundTripFlight ? "Please select a departing and returning date" : "Please select a departing date" : undefined;
};


/***/ }),

/***/ 29735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BF": function() { return /* binding */ generateRecentSearchDataKey; },
/* harmony export */   "PP": function() { return /* binding */ AIR_SEARCH_DATA; },
/* harmony export */   "Tw": function() { return /* binding */ PACKAGE_SEARCH_DATA; },
/* harmony export */   "al": function() { return /* binding */ persistSearchData; },
/* harmony export */   "rC": function() { return /* binding */ getProductType; },
/* harmony export */   "xj": function() { return /* binding */ CAR_SEARCH_DATA; },
/* harmony export */   "xl": function() { return /* binding */ getPersistedSearchDataByKeys; },
/* harmony export */   "yO": function() { return /* binding */ HOTEL_SEARCH_DATA; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var localforage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69483);
/* harmony import */ var localforage__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(localforage__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_products__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27204);






// exported to be reused when setting/getting saved searches
var AIR_SEARCH_DATA = "AIR_SEARCH_DATA";
var CAR_SEARCH_DATA = "CAR_SEARCH_DATA";
var HOTEL_SEARCH_DATA = "HOTEL_SEARCH_DATA";
var PACKAGE_SEARCH_DATA = "PACKAGE_SEARCH_DATA";
function isSavedSearch(item) {
    return item !== null && item !== undefined;
}
function getPersistedSearchData(key) {
    return localforage__WEBPACK_IMPORTED_MODULE_0___default().getItem(key);
}
function getPersistedSearchDataByKeys(keys) {
    return _getPersistedSearchDataByKeys.apply(this, arguments);
}
function _getPersistedSearchDataByKeys() {
    _getPersistedSearchDataByKeys = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(keys) {
        var sort, promiseResultsArray, results;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sort = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    return [
                        4,
                        Promise.all(keys.map(getPersistedSearchData))
                    ];
                case 1:
                    promiseResultsArray = _state.sent();
                    results = [];
                    try {
                        results = promiseResultsArray.flat().filter(isSavedSearch);
                    } catch (e) {
                        return [
                            2,
                            []
                        ];
                    }
                    // sort is by most recently saved
                    if (sort) {
                        return [
                            2,
                            results.sort(function(a, b) {
                                if (a.timestamp && b.timestamp) {
                                    return b.timestamp - a.timestamp;
                                }
                                return 0;
                            })
                        ];
                    }
                    return [
                        2,
                        results
                    ];
            }
        });
    });
    return _getPersistedSearchDataByKeys.apply(this, arguments);
}
var getProductType = function(item) {
    var tripType = item.tripType;
    switch(tripType){
        case "STAY":
            return _constants_products__WEBPACK_IMPORTED_MODULE_3__/* .HOTEL_PRODUCT_TYPE */ .kd;
        case "AH":
            return _constants_products__WEBPACK_IMPORTED_MODULE_3__/* .RENTAL_CAR_PRODUCT_TYPE */ .Jz;
        default:
            return _constants_products__WEBPACK_IMPORTED_MODULE_3__/* .VACATION_PACKAGE_PRODUCT_TYPE */ .nu;
    }
};
var generateRecentSearchDataKey = function(item) {
    var ref, ref1;
    var productType = getProductType(item);
    var ref2, ref3;
    return "".concat(item.startDate, "+").concat(item.endDate, "+").concat((ref2 = (ref = item.startLocation) === null || ref === void 0 ? void 0 : ref.cityID) !== null && ref2 !== void 0 ? ref2 : "", "+").concat((ref3 = (ref1 = item.endLocation) === null || ref1 === void 0 ? void 0 : ref1.cityID) !== null && ref3 !== void 0 ? ref3 : "", "+").concat(productType);
};
var isDuplicateSearch = function(recentSearchData, recentSearches) {
    return recentSearches === null || recentSearches === void 0 ? void 0 : recentSearches.some(function(prevSearchedProduct) {
        var prev = generateRecentSearchDataKey(prevSearchedProduct);
        var current = generateRecentSearchDataKey(recentSearchData);
        return prev === current;
    });
};
function persistSearchData(key, recentSearchData) {
    return _persistSearchData.apply(this, arguments);
}
function _persistSearchData() {
    _persistSearchData = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(key, recentSearchData) {
        var timestamp, recentSearch, groupDifferentProductTypeRecentSearches, storedSearchesByKey, storedSearches, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    timestamp = Date.now();
                    recentSearch = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, recentSearchData), {
                        timestamp: timestamp
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    if (!(key === PACKAGE_SEARCH_DATA || key === HOTEL_SEARCH_DATA)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        getPersistedSearchDataByKeys([
                            PACKAGE_SEARCH_DATA,
                            HOTEL_SEARCH_DATA
                        ], true)
                    ];
                case 2:
                    groupDifferentProductTypeRecentSearches = _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        getPersistedSearchData(key)
                    ];
                case 4:
                    storedSearchesByKey = _state.sent();
                    storedSearches = groupDifferentProductTypeRecentSearches !== null && groupDifferentProductTypeRecentSearches !== void 0 ? groupDifferentProductTypeRecentSearches : storedSearchesByKey;
                    if ([
                        HOTEL_SEARCH_DATA,
                        PACKAGE_SEARCH_DATA
                    ].includes(key) && isDuplicateSearch(recentSearchData, storedSearches)) {
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        localforage__WEBPACK_IMPORTED_MODULE_0___default().setItem(key, [
                            recentSearch,
                            storedSearchesByKey === null || storedSearchesByKey === void 0 ? void 0 : storedSearchesByKey[0],
                            storedSearchesByKey === null || storedSearchesByKey === void 0 ? void 0 : storedSearchesByKey[1]
                        ].filter(Boolean))
                    ];
                case 5:
                    e = _state.sent();
                    return [
                        2,
                        localforage__WEBPACK_IMPORTED_MODULE_0___default().setItem(key, [
                            recentSearch
                        ])
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return _persistSearchData.apply(this, arguments);
}


/***/ }),

/***/ 57809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ packages_search; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@pcln/build-shop-search-form/dist/esm/buildShopSearchForm.js + 1 modules
var buildShopSearchForm = __webpack_require__(83389);
// EXTERNAL MODULE: ./src/utils/date-helper.tsx
var date_helper = __webpack_require__(68511);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@pcln/build-shop-search-form/dist/esm/getPlaceData.js
var getPlaceData = __webpack_require__(19769);
;// CONCATENATED MODULE: ./src/utils/get-components-from-triptypes.ts





var getComponentsFromTripType = function(tripType, option) {
    var index = 0;
    var addProductToComponents = function(productItem, components, shouldUnshift) {
        var updatedComponents = (0,_to_consumable_array/* default */.Z)(components);
        if (shouldUnshift) {
            updatedComponents.unshift(productItem);
        } else {
            updatedComponents.push(productItem);
        }
        index += 1;
        return updatedComponents;
    };
    // eslint-disable-next-line @typescript-eslint/no-shadow
    var addHotelToComponents = function(components, option) {
        var productItem = {
            productId: 5,
            index: index,
            type: "STAY",
            query: (0,_object_spread/* default */.Z)({
                totalNumRooms: option.roomCount
            }, option.hotelLocation ? {
                destination: option.hotelLocation
            } : {}, option.isPartialStayDateValid ? {
                travelStartDate: {
                    value: option.hotelStartDate
                },
                travelEndDate: {
                    value: option.hotelEndDate
                }
            } : {})
        };
        return addProductToComponents(productItem, components, true);
    };
    var addFlightToComponents = function(components) {
        var productItem = {
            productId: 1,
            index: index,
            type: "FLY",
            query: {
                includeBasicEconomy: option.includeBasicEconomy
            }
        };
        return addProductToComponents(productItem, components);
    };
    var getRCPlaceData = function(carLocation) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,getPlaceData/* default */.Z)(carLocation)), {
            cityName: carLocation.cityName,
            lat: carLocation.lat,
            lon: carLocation.lon,
            stateCode: carLocation.stateCode,
            postalCode: carLocation.postalCode,
            addressLine1: carLocation.addressLine1
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-shadow
    var addCarToComponents = function(components, option) {
        var productItem = (0,_object_spread/* default */.Z)({
            productId: 8,
            type: "DRIVE",
            index: index
        }, option.isCarRequired ? {} : {
            isRequired: false
        });
        if (option.pickupCarSomewhere && option.rcPickupDate && option.rcDropoffDate && option.rcLocation) {
            var productItemWithQuery = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, productItem), {
                query: {
                    pickupDateTime: "".concat((0,date_helper/* formatDate */.p6)(option.rcPickupDate, "yyyy-MM-dd"), "T").concat(option.rcPickupTime),
                    returnDateTime: "".concat((0,date_helper/* formatDate */.p6)(option.rcDropoffDate, "yyyy-MM-dd"), "T").concat(option.rcDropoffTime),
                    pickupLocation: getRCPlaceData(option.rcLocation),
                    returnLocation: getRCPlaceData(option.rcLocation),
                    isIncludeAirportLocations: option.pickupCarIncludeAirport
                }
            });
            return addProductToComponents(productItemWithQuery, components);
        }
        return addProductToComponents(productItem, components);
    };
    // eslint-disable-next-line @typescript-eslint/no-shadow
    var mapComponent = function(components, type, option) {
        switch(type){
            case "STAY":
                return addHotelToComponents(components, option);
            case "FLY":
                return addFlightToComponents(components);
            case "DRIVE":
                return addCarToComponents(components, option);
            default:
                return components;
        }
    };
    return tripType.split(":").reduce(function(components, type) {
        return mapComponent(components, type, option);
    }, []);
};
/* harmony default export */ var get_components_from_triptypes = (getComponentsFromTripType);

;// CONCATENATED MODULE: ./src/utils/packages-search.ts





var packagesSearch = function(_param) {
    var _roomCount = _param.roomCount, roomCount = _roomCount === void 0 ? 1 : _roomCount, _adultCount = _param.adultCount, adultCount = _adultCount === void 0 ? 2 : _adultCount, _childrenCount = _param.childrenCount, childrenCount = _childrenCount === void 0 ? 0 : _childrenCount, _childrenAges = _param.childrenAges, childrenAges = _childrenAges === void 0 ? [] : _childrenAges, _startDate = _param.startDate, startDate = _startDate === void 0 ? "" : _startDate, _endDate = _param.endDate, endDate = _endDate === void 0 ? "" : _endDate, startLocationObject = _param.startLocationObject, endLocationObject = _param.endLocationObject, _hotelStartDate = _param.hotelStartDate, hotelStartDate = _hotelStartDate === void 0 ? "" : _hotelStartDate, _hotelEndDate = _param.hotelEndDate, hotelEndDate = _hotelEndDate === void 0 ? "" : _hotelEndDate, _tripType = _param.tripType, tripType = _tripType === void 0 ? "STAY:FLY" : _tripType, isPartialStayDateValid = _param.isPartialStayDateValid, _isRecommendedTrip = _param.isRecommendedTrip, isRecommendedTrip = _isRecommendedTrip === void 0 ? false : _isRecommendedTrip, _includeBasicEconomy = _param.includeBasicEconomy, includeBasicEconomy = _includeBasicEconomy === void 0 ? true : _includeBasicEconomy, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "roomCount",
        "adultCount",
        "childrenCount",
        "childrenAges",
        "startDate",
        "endDate",
        "startLocationObject",
        "endLocationObject",
        "hotelStartDate",
        "hotelEndDate",
        "tripType",
        "isPartialStayDateValid",
        "isRecommendedTrip",
        "includeBasicEconomy"
    ]);
    var url = "/shop/search/";
    var childrenAgesMock = {};
    if (childrenCount > 0) {
        childrenAges.forEach(function(item, i) {
            var index = i + 1;
            var key = "child".concat(index);
            childrenAgesMock[key] = item;
        });
    }
    var searchRequest = {
        rooms: roomCount,
        adultCount: adultCount,
        childCount: childrenCount,
        children: childrenAgesMock,
        departureDate: (0,date_helper/* formatDate */.p6)(startDate),
        departureLocation: startLocationObject || endLocationObject,
        returnDate: (0,date_helper/* formatDate */.p6)(endDate),
        arrivalLocation: endLocationObject,
        pivotComponentKey: 0,
        isRecommendedTrip: isRecommendedTrip,
        components: get_components_from_triptypes(tripType, (0,_object_spread/* default */.Z)({
            isPartialStayDateValid: isPartialStayDateValid,
            includeBasicEconomy: includeBasicEconomy,
            hotelStartDate: (0,date_helper/* formatDate */.p6)(hotelStartDate, "yyyy-MM-dd"),
            hotelEndDate: (0,date_helper/* formatDate */.p6)(hotelEndDate, "yyyy-MM-dd"),
            hotelLocation: endLocationObject === null || endLocationObject === void 0 ? void 0 : endLocationObject.city,
            roomCount: roomCount,
            isCarRequired: tripType.includes("DRIVE")
        }, rest))
    };
    var form = (0,buildShopSearchForm/* default */.Z)(url, searchRequest);
    form.submit();
};
/* harmony default export */ var packages_search = (packagesSearch);


/***/ })

}]);